unit View.Cupons.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  WEBLib.Lists, WEBLib.Grids, Grid.Plugins, UConstantes, System.StrUtils,
  UUtils, UWeb.Enum, UHelperServer;

type
  TFViewCuponsEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbcliente_id: TLabel;
    edcliente_id: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbcaixa: TLabel;
    edcaixa: TDBEdit;
    lbnumero: TLabel;
    ednumero: TDBEdit;
    lbdoc_auxiliar: TLabel;
    eddoc_auxiliar: TDBEdit;
    lbcoo: TLabel;
    edcoo: TDBEdit;
    lbmodelo: TLabel;
    edmodelo: TDBEdit;
    lbdata_emissao: TLabel;
    eddata_emissao: TDBEdit;
    lbdata_saida: TLabel;
    eddata_saida: TDBEdit;
    lbvalor_acrescimos: TLabel;
    edvalor_acrescimos: TDBEdit;
    lbvalor_descontos: TLabel;
    edvalor_descontos: TDBEdit;
    lbvalor_base_calculo_icms: TLabel;
    edvalor_base_calculo_icms: TDBEdit;
    lbvalor_icms: TLabel;
    edvalor_icms: TDBEdit;
    lbvalor_total_itens: TLabel;
    edvalor_total_itens: TDBEdit;
    lbvalor_total: TLabel;
    edvalor_total: TDBEdit;
    lbcodigo_venda_conciliada: TLabel;
    edcodigo_venda_conciliada: TDBEdit;
    lbobservacoes: TLabel;
    edobservacoes: TDBEdit;
    lbdata_movimento: TLabel;
    eddata_movimento: TDBEdit;
    lbsinc_scanntech: TLabel;
    edsinc_scanntech: TDBEdit;
    lbvalor_desconto_scanntech: TLabel;
    edvalor_desconto_scanntech: TDBEdit;
    lbexcluiu_icms_base_pis_cofins: TLabel;
    lbexcluiu_fcp_base_pis_cofins: TLabel;
    lbcupom_cancelado: TLabel;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCuponsGet: TXDataWebClient;
    CuponsDataset: TXDataWebDataSet;
    CuponsDatasetid: TIntegerField;
    CuponsDatasetaliado_id: TIntegerField;
    CuponsDatasetdata_base_id: TIntegerField;
    CuponsDatasetcliente_id: TIntegerField;
    CuponsDatasetfuncionario_id: TIntegerField;
    CuponsDatasetcaixa: TIntegerField;
    CuponsDatasetnumero: TStringField;
    CuponsDatasetdoc_auxiliar: TStringField;
    CuponsDatasetcoo: TStringField;
    CuponsDatasetmodelo: TStringField;
    CuponsDatasetdata_emissao: TDateTimeField;
    CuponsDatasetdata_saida: TDateTimeField;
    CuponsDatasetvalor_acrescimos: TFloatField;
    CuponsDatasetvalor_descontos: TFloatField;
    CuponsDatasetvalor_base_calculo_icms: TFloatField;
    CuponsDatasetvalor_icms: TFloatField;
    CuponsDatasetvalor_total_itens: TFloatField;
    CuponsDatasetvalor_total: TFloatField;
    CuponsDatasetcliente_fidelidade_id: TIntegerField;
    CuponsDatasetcodigo_venda_conciliada: TIntegerField;
    CuponsDatasetorcamentos_id: TIntegerField;
    CuponsDatasetosv_oss_id: TIntegerField;
    CuponsDatasetdependentes_id: TIntegerField;
    CuponsDatasetose_oss_id: TIntegerField;
    CuponsDatasetobservacoes: TStringField;
    CuponsDatasetnome_consumidor_final: TStringField;
    CuponsDatasetcpf_cnpj_consumidor_final: TStringField;
    CuponsDatasetdata_movimento: TDateTimeField;
    CuponsDatasetrotas_id: TIntegerField;
    CuponsDatasetconvenios_id: TIntegerField;
    CuponsDatasetsinc_scanntech: TDateTimeField;
    CuponsDatasetvalor_desconto_scanntech: TFloatField;
    CuponsDatasetnfce_id: TIntegerField;
    CuponsDatasetexcluiu_icms_base_pis_cofins: TBooleanField;
    CuponsDatasetexcluiu_fcp_base_pis_cofins: TBooleanField;
    CuponsDatasetcupom_cancelado: TBooleanField;
    CuponsDatasetcodigo_interno: TIntegerField;
    CuponsDatasetexcluido: TBooleanField;
    CuponsDatasetinclusao: TDateTimeField;
    CuponsDatasetalteracao: TDateTimeField;
    CuponsDatasetexclusao: TDateTimeField;
    pnlFormDados: TPanel;
    cbxexcluido: TDBCheckBox;
    cbxexcluiu_icms_base_pis_cofins: TDBCheckBox;
    cbxexcluiu_fcp_base_pis_cofins: TDBCheckBox;
    cbxcupom_cancelado: TDBCheckBox;
    lbPaginationInfoItens: TLabel;
    tblItens: TDBTableControl;
    cbPageSizeItens: TComboBox;
    edSearchItens: TEdit;
    pnlItensPromocao: TPanel;
    btnItensTab: TButton;
    lcPaginatorItens: TListControl;
    cdsItens: TXDataWebDataSet;
    dtsItens: TDataSource;
    tmrConsultaItens: TTimer;
    cdsItensproduto_id: TIntegerField;
    cdsItensitem: TIntegerField;
    cdsItensquantidade: TFloatField;
    cdsItensproduto_preco: TFloatField;
    cdsItensvalor_total: TFloatField;
    cdsItensproduto_nome: TStringField;
    cdsItensprodnome: TXDataWebDatasetField;
    cdsItensprodcodigo_interno: TXDataWebDatasetField;
    cdsItensunidadesigla: TStringField;
    lbPaginationInfoAReceber: TLabel;
    lbPaginationInfoRecebimentos: TLabel;
    pnlTabelaAReceber: TPanel;
    tblAReceber: TDBTableControl;
    lcPaginatorAReceber: TListControl;
    tblRecebimentos: TDBTableControl;
    pnlTabelaPagamentos: TPanel;
    btnFinanceiroTab: TButton;
    btnRecebimentosTab: TButton;
    lcPaginatorRecebimentos: TListControl;
    cdsRecebimentos: TXDataWebDataSet;
    cdsRecebimentosvalor_bruto_recebido: TFloatField;
    cdsRecebimentosdata_recebimento: TDateTimeField;
    cdsRecebimentosmodalidadenome: TStringField;
    cdsRecebimentosareceberdocumento: TStringField;
    cdsRecebimentosareceberparcela: TXDataWebDatasetField;
    dtsRecebimentos: TDataSource;
    dtsAReceber: TDataSource;
    cdsAReceber: TXDataWebDataSet;
    cdsAReceberdocumento: TStringField;
    cdsAReceberparcela: TStringField;
    cdsAReceberemissao: TDateTimeField;
    cdsARecebervencimento: TDateTimeField;
    cdsARecebervalor_total: TFloatField;
    cdsARecebervalor_saldo_pendente: TFloatField;
    cdsARecebervalor_pago: TFloatField;
    lbchave_acesso: TLabel;
    lbnfce_transmissao: TLabel;
    pnlFormNfce: TPanel;
    edchave_acesso: TDBEdit;
    ednfce_transmissao: TDBEdit;
    btnCopiarChaveAcesso: TButton;
    btnNfceTab: TButton;
    CuponsDatasetnfcedata_transmissao: TDateTimeField;
    CuponsDatasetnfcechave_acesso: TStringField;
    CuponsDatasetclienterazao_social_nome: TStringField;
    CuponsDatasetfuncionarionome: TStringField;
    lbnfce_cancelada: TLabel;
    cbxnfce_cancelada: TDBCheckBox;
    CuponsDatasetnfcenfce_cancelada: TBooleanField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientCuponsGetLoad(Response: TXDataClientResponse);
    procedure CuponsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure cdsItensproduto_nomeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cbPageSizeItensChange(Sender: TObject);
    procedure edSearchItensKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchItensKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaItensTimer(Sender: TObject);
    procedure btnItensTabClick(Sender: TObject);
    procedure tblItensGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure cdsItensitemGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure btnFinanceiroTabClick(Sender: TObject);
    procedure btnRecebimentosTabClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure tblAReceberGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblAReceberGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblRecebimentosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure btnNfceTabClick(Sender: TObject);
    procedure btnCopiarChaveAcessoClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginItens,
    FGridPluginAReceber,
    FGridPluginRecebimentos : TGridPlugin;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure CarregarAReceber;
    procedure CarregarRecebimentos;
    procedure ConfigurarPermissoes;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCuponsEdit: TFViewCuponsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCuponsEdit }

procedure TFViewCuponsEdit.btnCopiarChaveAcessoClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Chave de acesso copiada com sucesso!', 'Cópia de chave de acesso',
    edchave_acesso.Text);
end;

procedure TFViewCuponsEdit.btnFinanceiroTabClick(Sender: TObject);
begin
  if TUtils.PossuiPermissao(cdsAReceber.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
    CarregarAReceber
  else
  begin
    TUtils.SelecionarTab('#line-recebimentos-tab');
    CarregarRecebimentos;
  end;
end;

procedure TFViewCuponsEdit.btnItensTabClick(Sender: TObject);
begin
  if cdsItens.Tag = 0 then
  begin
    cdsItens.Tag := 1;

    FGridPluginItens := TGridPlugin.Create(tblItens, cdsItens, lcPaginatorItens, lbPaginationInfoItens);
    FGridPluginItens.FDatasetPlugin.FFilterPadrao := '(cupons_id eq ' + edid.Text +')';
    FGridPluginItens.FDatasetPlugin.FOrderByPadrao := 'item asc';
    FGridPluginItens.SetPageSize(StrToInt(cbPageSizeItens.Text));
    FGridPluginItens.SetFilterText(edSearchItens.Text);
    FGridPluginItens.Load;
  end;
end;

procedure TFViewCuponsEdit.btnNfceTabClick(Sender: TObject);
begin
  if edchave_acesso.Text = '' then
    btnCopiarChaveAcesso.Enabled := False;
end;

procedure TFViewCuponsEdit.btnRecebimentosTabClick(Sender: TObject);
begin
  CarregarRecebimentos;
end;

procedure TFViewCuponsEdit.CarregarAReceber;
begin
  if cdsAReceber.Tag = 0 then
  begin
    cdsAReceber.Tag := 1;

    FGridPluginAReceber := TGridPlugin.Create(tblAReceber, cdsAReceber, lcPaginatorAReceber,
      lbPaginationInfoAReceber);
    FGridPluginAReceber.FDatasetPlugin.FFilterPadrao := '(cupons_id eq ' + edid.Text +')';
    FGridPluginAReceber.FDatasetPlugin.FOrderByPadrao := 'vencimento asc';
    FGridPluginAReceber.SetPageSize(10);
    FGridPluginAReceber.SetFilterText(EmptyStr);
    FGridPluginAReceber.Load;
  end;
end;

procedure TFViewCuponsEdit.CarregarRecebimentos;
begin
  if cdsRecebimentos.Tag = 0 then
  begin
    cdsRecebimentos.Tag := 1;

    FGridPluginRecebimentos := TGridPlugin.Create(tblRecebimentos, cdsRecebimentos, lcPaginatorRecebimentos,
      lbPaginationInfoRecebimentos);
    FGridPluginRecebimentos.FDatasetPlugin.FFilterPadrao := '(areceber/cupons_id eq ' + edid.Text +')';
    FGridPluginRecebimentos.FDatasetPlugin.FOrderByPadrao := 'data_recebimento desc, codigo_interno desc';
    FGridPluginRecebimentos.SetPageSize(10);
    FGridPluginRecebimentos.SetFilterText(EmptyStr);
    FGridPluginRecebimentos.Load;
  end;
end;

procedure TFViewCuponsEdit.cbPageSizeItensChange(Sender: TObject);
begin
  FGridPluginItens.SetPageSize(StrToInt(cbPageSizeItens.Text), True);
end;

procedure TFViewCuponsEdit.cdsItensitemGetText(Sender: TField; var Text: string;
  DisplayText: Boolean);
begin
  Text := Format('%.3d', [Sender.AsInteger]);
end;

procedure TFViewCuponsEdit.cdsItensproduto_nomeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Text := cdsItens.FieldByName('prod.nome').AsString
  else
    Text := Sender.AsString;
end;

procedure TFViewCuponsEdit.ConfigurarPermissoes;
begin

end;

class function TFViewCuponsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCuponsEdit.InsertEntity;
begin
  CuponsDataset.Close;
  CuponsDataset.SetJsonData('{}');
  CuponsDataset.Open;
  CuponsDataset.Insert;
end;

class function TFViewCuponsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCuponsEdit(AForm).FInserting := AInserting;
    TFViewCuponsEdit(AForm).FId := AId;
    TFViewCuponsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCuponsEdit(AForm).InsertEntity
    else
      TFViewCuponsEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewCuponsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCuponsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    CuponsDataset.Connection.Model.DefaultSchema.FindEntityType(
      CuponsDataset.EntitySetName
    )
  );
  XDataClientCuponsGet.Get(CuponsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCuponsEdit.tblAReceberGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblAReceber.Columns[ACol].DataField, ['valor_total', 'valor_saldo_pendente',
      'valor_pago', 'documento']) of
      0, 1, 2: AClassName := 'text-end';
      3: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewCuponsEdit.tblAReceberGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
var
  lTituloVencido : Boolean;
begin
  if ARow > 0 then
  begin
    lTituloVencido := (tblAReceber.DataSource.DataSet.FieldByName('valor_saldo_pendente').AsFloat > 0) and
      (StrToDate(tblAReceber.DataSource.DataSet.FieldByName('vencimento').AsString) < Date);

    if lTituloVencido then
      AValue := '<p class="text-danger">' + AValue + '</p>'
  end;
end;

procedure TFViewCuponsEdit.tblItensGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblItens.Columns[ACol].DataField, ['produto_nome', 'quantidade',
     'produto_preco', 'valor_total']) of
      0: AClassName := 'text-start';
      1, 2, 3: AClassName := 'text-end'
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewCuponsEdit.tblRecebimentosGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if cdsRecebimentos.Tag = 0 then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblRecebimentos.Columns[ACol].DataField, ['valor_bruto_recebido', 'modalidade.nome',
      'areceber.documento']) of
      0: AClassName := 'text-end';
      1, 2: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewCuponsEdit.tmrConsultaItensTimer(Sender: TObject);
begin
  FGridPluginItens.SetFilterText(edSearchItens.Text, True);

  tmrConsultaItens.Enabled := False;
  tmrConsultaItens.Interval := FTimerConsulta;
end;

procedure TFViewCuponsEdit.WebFormShow(Sender: TObject);
begin
  ConfigurarPermissoes;
end;

procedure TFViewCuponsEdit.XDataClientCuponsGetLoad(Response: TXDataClientResponse);
begin
  CuponsDataset.Close;
  CuponsDataset.SetJsonData(Response.Result);
  CuponsDataset.Open;
  
  CuponsDataset.Edit;  
end;

procedure TFViewCuponsEdit.CuponsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCuponsEdit.edSearchItensKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaItens.Enabled := False;

  if Key = 13 then
    FGridPluginItens.SetFilterText(edSearchItens.Text, True);
end;

procedure TFViewCuponsEdit.edSearchItensKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaItens.Interval := FTimerConsulta;
  tmrConsultaItens.Enabled := True;
end;

procedure TFViewCuponsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCuponsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.cupons.form.lbid');
  lbcliente_id := TLabel.Create('view.cupons.form.lbcliente_id');
  lbfuncionario_id := TLabel.Create('view.cupons.form.lbfuncionario_id');
  lbcaixa := TLabel.Create('view.cupons.form.lbcaixa');
  lbnumero := TLabel.Create('view.cupons.form.lbnumero');
  lbdoc_auxiliar := TLabel.Create('view.cupons.form.lbdoc_auxiliar');
  lbcoo := TLabel.Create('view.cupons.form.lbcoo');
  lbmodelo := TLabel.Create('view.cupons.form.lbmodelo');
  lbdata_emissao := TLabel.Create('view.cupons.form.lbdata_emissao');
  lbdata_saida := TLabel.Create('view.cupons.form.lbdata_saida');
  lbvalor_acrescimos := TLabel.Create('view.cupons.form.lbvalor_acrescimos');
  lbvalor_descontos := TLabel.Create('view.cupons.form.lbvalor_descontos');
  lbvalor_base_calculo_icms := TLabel.Create('view.cupons.form.lbvalor_base_calculo_icms');
  lbvalor_icms := TLabel.Create('view.cupons.form.lbvalor_icms');
  lbvalor_total_itens := TLabel.Create('view.cupons.form.lbvalor_total_itens');
  lbvalor_total := TLabel.Create('view.cupons.form.lbvalor_total');
  lbcodigo_venda_conciliada := TLabel.Create('view.cupons.form.lbcodigo_venda_conciliada');
  lbobservacoes := TLabel.Create('view.cupons.form.lbobservacoes');
  lbdata_movimento := TLabel.Create('view.cupons.form.lbdata_movimento');
  lbsinc_scanntech := TLabel.Create('view.cupons.form.lbsinc_scanntech');
  lbvalor_desconto_scanntech := TLabel.Create('view.cupons.form.lbvalor_desconto_scanntech');
  lbexcluiu_icms_base_pis_cofins := TLabel.Create('view.cupons.form.lbexcluiu_icms_base_pis_cofins');
  lbexcluiu_fcp_base_pis_cofins := TLabel.Create('view.cupons.form.lbexcluiu_fcp_base_pis_cofins');
  lbcupom_cancelado := TLabel.Create('view.cupons.form.lbcupom_cancelado');
  lbcodigo_interno := TLabel.Create('view.cupons.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.cupons.form.lbexcluido');
  lbinclusao := TLabel.Create('view.cupons.form.lbinclusao');
  lbalteracao := TLabel.Create('view.cupons.form.lbalteracao');
  lbexclusao := TLabel.Create('view.cupons.form.lbexclusao');
  lbPaginationInfoItens := TLabel.Create('lbPaginationInfoItens');
  lbPaginationInfoAReceber := TLabel.Create('lbPaginationInfoAReceber');
  lbPaginationInfoRecebimentos := TLabel.Create('lbPaginationInfoRecebimentos');
  lbchave_acesso := TLabel.Create('view.cupons.form.lbchave_acesso');
  lbnfce_transmissao := TLabel.Create('view.cupons.form.lbnfce_transmissao');
  lbnfce_cancelada := TLabel.Create('view.cupons.form.lbnfce_cancelada');
  btCancel := TButton.Create('view.cupons.form.btBack');
  edid := TDBEdit.Create('view.cupons.form.edid');
  edcliente_id := TDBEdit.Create('view.cupons.form.edcliente_id');
  edfuncionario_id := TDBEdit.Create('view.cupons.form.edfuncionario_id');
  edcaixa := TDBEdit.Create('view.cupons.form.edcaixa');
  ednumero := TDBEdit.Create('view.cupons.form.ednumero');
  eddoc_auxiliar := TDBEdit.Create('view.cupons.form.eddoc_auxiliar');
  edcoo := TDBEdit.Create('view.cupons.form.edcoo');
  edmodelo := TDBEdit.Create('view.cupons.form.edmodelo');
  eddata_emissao := TDBEdit.Create('view.cupons.form.eddata_emissao');
  eddata_saida := TDBEdit.Create('view.cupons.form.eddata_saida');
  edvalor_acrescimos := TDBEdit.Create('view.cupons.form.edvalor_acrescimos');
  edvalor_descontos := TDBEdit.Create('view.cupons.form.edvalor_descontos');
  edvalor_base_calculo_icms := TDBEdit.Create('view.cupons.form.edvalor_base_calculo_icms');
  edvalor_icms := TDBEdit.Create('view.cupons.form.edvalor_icms');
  edvalor_total_itens := TDBEdit.Create('view.cupons.form.edvalor_total_itens');
  edvalor_total := TDBEdit.Create('view.cupons.form.edvalor_total');
  edcodigo_venda_conciliada := TDBEdit.Create('view.cupons.form.edcodigo_venda_conciliada');
  edobservacoes := TDBEdit.Create('view.cupons.form.edobservacoes');
  eddata_movimento := TDBEdit.Create('view.cupons.form.eddata_movimento');
  edsinc_scanntech := TDBEdit.Create('view.cupons.form.edsinc_scanntech');
  edvalor_desconto_scanntech := TDBEdit.Create('view.cupons.form.edvalor_desconto_scanntech');
  edcodigo_interno := TDBEdit.Create('view.cupons.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.cupons.form.edinclusao');
  edalteracao := TDBEdit.Create('view.cupons.form.edalteracao');
  edexclusao := TDBEdit.Create('view.cupons.form.edexclusao');
  pnlFormDados := TPanel.Create(Self);
  cbxexcluido := TDBCheckBox.Create('view.cupons.form.cbxexcluido');
  cbxexcluiu_icms_base_pis_cofins := TDBCheckBox.Create('view.cupons.form.cbxexcluiu_icms_base_pis_cofins');
  cbxexcluiu_fcp_base_pis_cofins := TDBCheckBox.Create('view.cupons.form.cbxexcluiu_fcp_base_pis_cofins');
  cbxcupom_cancelado := TDBCheckBox.Create('view.cupons.form.cbxcupom_cancelado');
  tblItens := TDBTableControl.Create('tblItens');
  cbPageSizeItens := TComboBox.Create('cbPageSizeItens');
  edSearchItens := TEdit.Create('edSearchItens');
  pnlItensPromocao := TPanel.Create(Self);
  btnItensTab := TButton.Create('line-itens-tab');
  lcPaginatorItens := TListControl.Create('lcPaginatorItens');
  pnlTabelaAReceber := TPanel.Create(Self);
  tblAReceber := TDBTableControl.Create('tblAReceber');
  lcPaginatorAReceber := TListControl.Create('lcPaginatorAReceber');
  tblRecebimentos := TDBTableControl.Create('tblRecebimentos');
  pnlTabelaPagamentos := TPanel.Create(Self);
  btnFinanceiroTab := TButton.Create('line-financeiro-tab');
  btnRecebimentosTab := TButton.Create('line-recebimentos-tab');
  lcPaginatorRecebimentos := TListControl.Create('lcPaginatorRecebimentos');
  pnlFormNfce := TPanel.Create(Self);
  edchave_acesso := TDBEdit.Create('view.cupons.form.edchave_acesso');
  ednfce_transmissao := TDBEdit.Create('view.cupons.form.ednfce_transmissao');
  btnCopiarChaveAcesso := TButton.Create('btnCopiarChaveAcesso');
  btnNfceTab := TButton.Create('line-nfce-tab');
  cbxnfce_cancelada := TDBCheckBox.Create('view.cupons.form.cbxnfce_cancelada');
  DataSource := TDataSource.Create(Self);
  CuponsDataset := TXDataWebDataSet.Create(Self);
  CuponsDatasetid := TIntegerField.Create(Self);
  CuponsDatasetaliado_id := TIntegerField.Create(Self);
  CuponsDatasetdata_base_id := TIntegerField.Create(Self);
  CuponsDatasetcliente_id := TIntegerField.Create(Self);
  CuponsDatasetfuncionario_id := TIntegerField.Create(Self);
  CuponsDatasetcaixa := TIntegerField.Create(Self);
  CuponsDatasetnumero := TStringField.Create(Self);
  CuponsDatasetdoc_auxiliar := TStringField.Create(Self);
  CuponsDatasetcoo := TStringField.Create(Self);
  CuponsDatasetmodelo := TStringField.Create(Self);
  CuponsDatasetdata_emissao := TDateTimeField.Create(Self);
  CuponsDatasetdata_saida := TDateTimeField.Create(Self);
  CuponsDatasetvalor_acrescimos := TFloatField.Create(Self);
  CuponsDatasetvalor_descontos := TFloatField.Create(Self);
  CuponsDatasetvalor_base_calculo_icms := TFloatField.Create(Self);
  CuponsDatasetvalor_icms := TFloatField.Create(Self);
  CuponsDatasetvalor_total_itens := TFloatField.Create(Self);
  CuponsDatasetvalor_total := TFloatField.Create(Self);
  CuponsDatasetcliente_fidelidade_id := TIntegerField.Create(Self);
  CuponsDatasetcodigo_venda_conciliada := TIntegerField.Create(Self);
  CuponsDatasetorcamentos_id := TIntegerField.Create(Self);
  CuponsDatasetosv_oss_id := TIntegerField.Create(Self);
  CuponsDatasetdependentes_id := TIntegerField.Create(Self);
  CuponsDatasetose_oss_id := TIntegerField.Create(Self);
  CuponsDatasetobservacoes := TStringField.Create(Self);
  CuponsDatasetnome_consumidor_final := TStringField.Create(Self);
  CuponsDatasetcpf_cnpj_consumidor_final := TStringField.Create(Self);
  CuponsDatasetdata_movimento := TDateTimeField.Create(Self);
  CuponsDatasetrotas_id := TIntegerField.Create(Self);
  CuponsDatasetconvenios_id := TIntegerField.Create(Self);
  CuponsDatasetsinc_scanntech := TDateTimeField.Create(Self);
  CuponsDatasetvalor_desconto_scanntech := TFloatField.Create(Self);
  CuponsDatasetnfce_id := TIntegerField.Create(Self);
  CuponsDatasetexcluiu_icms_base_pis_cofins := TBooleanField.Create(Self);
  CuponsDatasetexcluiu_fcp_base_pis_cofins := TBooleanField.Create(Self);
  CuponsDatasetcupom_cancelado := TBooleanField.Create(Self);
  CuponsDatasetcodigo_interno := TIntegerField.Create(Self);
  CuponsDatasetexcluido := TBooleanField.Create(Self);
  CuponsDatasetinclusao := TDateTimeField.Create(Self);
  CuponsDatasetalteracao := TDateTimeField.Create(Self);
  CuponsDatasetexclusao := TDateTimeField.Create(Self);
  CuponsDatasetnfcedata_transmissao := TDateTimeField.Create(Self);
  CuponsDatasetnfcechave_acesso := TStringField.Create(Self);
  CuponsDatasetclienterazao_social_nome := TStringField.Create(Self);
  CuponsDatasetfuncionarionome := TStringField.Create(Self);
  CuponsDatasetnfcenfce_cancelada := TBooleanField.Create(Self);
  XDataClientCuponsGet := TXDataWebClient.Create(Self);
  cdsItens := TXDataWebDataSet.Create(Self);
  cdsItensproduto_id := TIntegerField.Create(Self);
  cdsItensitem := TIntegerField.Create(Self);
  cdsItensquantidade := TFloatField.Create(Self);
  cdsItensproduto_preco := TFloatField.Create(Self);
  cdsItensvalor_total := TFloatField.Create(Self);
  cdsItensproduto_nome := TStringField.Create(Self);
  cdsItensprodnome := TXDataWebDatasetField.Create(Self);
  cdsItensprodcodigo_interno := TXDataWebDatasetField.Create(Self);
  cdsItensunidadesigla := TStringField.Create(Self);
  dtsItens := TDataSource.Create(Self);
  tmrConsultaItens := TTimer.Create(Self);
  cdsRecebimentos := TXDataWebDataSet.Create(Self);
  cdsRecebimentosvalor_bruto_recebido := TFloatField.Create(Self);
  cdsRecebimentosdata_recebimento := TDateTimeField.Create(Self);
  cdsRecebimentosmodalidadenome := TStringField.Create(Self);
  cdsRecebimentosareceberdocumento := TStringField.Create(Self);
  cdsRecebimentosareceberparcela := TXDataWebDatasetField.Create(Self);
  dtsRecebimentos := TDataSource.Create(Self);
  dtsAReceber := TDataSource.Create(Self);
  cdsAReceber := TXDataWebDataSet.Create(Self);
  cdsAReceberdocumento := TStringField.Create(Self);
  cdsAReceberparcela := TStringField.Create(Self);
  cdsAReceberemissao := TDateTimeField.Create(Self);
  cdsARecebervencimento := TDateTimeField.Create(Self);
  cdsARecebervalor_total := TFloatField.Create(Self);
  cdsARecebervalor_saldo_pendente := TFloatField.Create(Self);
  cdsARecebervalor_pago := TFloatField.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbcliente_id.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  lbcaixa.BeforeLoadDFMValues;
  lbnumero.BeforeLoadDFMValues;
  lbdoc_auxiliar.BeforeLoadDFMValues;
  lbcoo.BeforeLoadDFMValues;
  lbmodelo.BeforeLoadDFMValues;
  lbdata_emissao.BeforeLoadDFMValues;
  lbdata_saida.BeforeLoadDFMValues;
  lbvalor_acrescimos.BeforeLoadDFMValues;
  lbvalor_descontos.BeforeLoadDFMValues;
  lbvalor_base_calculo_icms.BeforeLoadDFMValues;
  lbvalor_icms.BeforeLoadDFMValues;
  lbvalor_total_itens.BeforeLoadDFMValues;
  lbvalor_total.BeforeLoadDFMValues;
  lbcodigo_venda_conciliada.BeforeLoadDFMValues;
  lbobservacoes.BeforeLoadDFMValues;
  lbdata_movimento.BeforeLoadDFMValues;
  lbsinc_scanntech.BeforeLoadDFMValues;
  lbvalor_desconto_scanntech.BeforeLoadDFMValues;
  lbexcluiu_icms_base_pis_cofins.BeforeLoadDFMValues;
  lbexcluiu_fcp_base_pis_cofins.BeforeLoadDFMValues;
  lbcupom_cancelado.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbPaginationInfoItens.BeforeLoadDFMValues;
  lbPaginationInfoAReceber.BeforeLoadDFMValues;
  lbPaginationInfoRecebimentos.BeforeLoadDFMValues;
  lbchave_acesso.BeforeLoadDFMValues;
  lbnfce_transmissao.BeforeLoadDFMValues;
  lbnfce_cancelada.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edcliente_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  edcaixa.BeforeLoadDFMValues;
  ednumero.BeforeLoadDFMValues;
  eddoc_auxiliar.BeforeLoadDFMValues;
  edcoo.BeforeLoadDFMValues;
  edmodelo.BeforeLoadDFMValues;
  eddata_emissao.BeforeLoadDFMValues;
  eddata_saida.BeforeLoadDFMValues;
  edvalor_acrescimos.BeforeLoadDFMValues;
  edvalor_descontos.BeforeLoadDFMValues;
  edvalor_base_calculo_icms.BeforeLoadDFMValues;
  edvalor_icms.BeforeLoadDFMValues;
  edvalor_total_itens.BeforeLoadDFMValues;
  edvalor_total.BeforeLoadDFMValues;
  edcodigo_venda_conciliada.BeforeLoadDFMValues;
  edobservacoes.BeforeLoadDFMValues;
  eddata_movimento.BeforeLoadDFMValues;
  edsinc_scanntech.BeforeLoadDFMValues;
  edvalor_desconto_scanntech.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  pnlFormDados.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxexcluiu_icms_base_pis_cofins.BeforeLoadDFMValues;
  cbxexcluiu_fcp_base_pis_cofins.BeforeLoadDFMValues;
  cbxcupom_cancelado.BeforeLoadDFMValues;
  tblItens.BeforeLoadDFMValues;
  cbPageSizeItens.BeforeLoadDFMValues;
  edSearchItens.BeforeLoadDFMValues;
  pnlItensPromocao.BeforeLoadDFMValues;
  btnItensTab.BeforeLoadDFMValues;
  lcPaginatorItens.BeforeLoadDFMValues;
  pnlTabelaAReceber.BeforeLoadDFMValues;
  tblAReceber.BeforeLoadDFMValues;
  lcPaginatorAReceber.BeforeLoadDFMValues;
  tblRecebimentos.BeforeLoadDFMValues;
  pnlTabelaPagamentos.BeforeLoadDFMValues;
  btnFinanceiroTab.BeforeLoadDFMValues;
  btnRecebimentosTab.BeforeLoadDFMValues;
  lcPaginatorRecebimentos.BeforeLoadDFMValues;
  pnlFormNfce.BeforeLoadDFMValues;
  edchave_acesso.BeforeLoadDFMValues;
  ednfce_transmissao.BeforeLoadDFMValues;
  btnCopiarChaveAcesso.BeforeLoadDFMValues;
  btnNfceTab.BeforeLoadDFMValues;
  cbxnfce_cancelada.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  CuponsDataset.BeforeLoadDFMValues;
  CuponsDatasetid.BeforeLoadDFMValues;
  CuponsDatasetaliado_id.BeforeLoadDFMValues;
  CuponsDatasetdata_base_id.BeforeLoadDFMValues;
  CuponsDatasetcliente_id.BeforeLoadDFMValues;
  CuponsDatasetfuncionario_id.BeforeLoadDFMValues;
  CuponsDatasetcaixa.BeforeLoadDFMValues;
  CuponsDatasetnumero.BeforeLoadDFMValues;
  CuponsDatasetdoc_auxiliar.BeforeLoadDFMValues;
  CuponsDatasetcoo.BeforeLoadDFMValues;
  CuponsDatasetmodelo.BeforeLoadDFMValues;
  CuponsDatasetdata_emissao.BeforeLoadDFMValues;
  CuponsDatasetdata_saida.BeforeLoadDFMValues;
  CuponsDatasetvalor_acrescimos.BeforeLoadDFMValues;
  CuponsDatasetvalor_descontos.BeforeLoadDFMValues;
  CuponsDatasetvalor_base_calculo_icms.BeforeLoadDFMValues;
  CuponsDatasetvalor_icms.BeforeLoadDFMValues;
  CuponsDatasetvalor_total_itens.BeforeLoadDFMValues;
  CuponsDatasetvalor_total.BeforeLoadDFMValues;
  CuponsDatasetcliente_fidelidade_id.BeforeLoadDFMValues;
  CuponsDatasetcodigo_venda_conciliada.BeforeLoadDFMValues;
  CuponsDatasetorcamentos_id.BeforeLoadDFMValues;
  CuponsDatasetosv_oss_id.BeforeLoadDFMValues;
  CuponsDatasetdependentes_id.BeforeLoadDFMValues;
  CuponsDatasetose_oss_id.BeforeLoadDFMValues;
  CuponsDatasetobservacoes.BeforeLoadDFMValues;
  CuponsDatasetnome_consumidor_final.BeforeLoadDFMValues;
  CuponsDatasetcpf_cnpj_consumidor_final.BeforeLoadDFMValues;
  CuponsDatasetdata_movimento.BeforeLoadDFMValues;
  CuponsDatasetrotas_id.BeforeLoadDFMValues;
  CuponsDatasetconvenios_id.BeforeLoadDFMValues;
  CuponsDatasetsinc_scanntech.BeforeLoadDFMValues;
  CuponsDatasetvalor_desconto_scanntech.BeforeLoadDFMValues;
  CuponsDatasetnfce_id.BeforeLoadDFMValues;
  CuponsDatasetexcluiu_icms_base_pis_cofins.BeforeLoadDFMValues;
  CuponsDatasetexcluiu_fcp_base_pis_cofins.BeforeLoadDFMValues;
  CuponsDatasetcupom_cancelado.BeforeLoadDFMValues;
  CuponsDatasetcodigo_interno.BeforeLoadDFMValues;
  CuponsDatasetexcluido.BeforeLoadDFMValues;
  CuponsDatasetinclusao.BeforeLoadDFMValues;
  CuponsDatasetalteracao.BeforeLoadDFMValues;
  CuponsDatasetexclusao.BeforeLoadDFMValues;
  CuponsDatasetnfcedata_transmissao.BeforeLoadDFMValues;
  CuponsDatasetnfcechave_acesso.BeforeLoadDFMValues;
  CuponsDatasetclienterazao_social_nome.BeforeLoadDFMValues;
  CuponsDatasetfuncionarionome.BeforeLoadDFMValues;
  CuponsDatasetnfcenfce_cancelada.BeforeLoadDFMValues;
  XDataClientCuponsGet.BeforeLoadDFMValues;
  cdsItens.BeforeLoadDFMValues;
  cdsItensproduto_id.BeforeLoadDFMValues;
  cdsItensitem.BeforeLoadDFMValues;
  cdsItensquantidade.BeforeLoadDFMValues;
  cdsItensproduto_preco.BeforeLoadDFMValues;
  cdsItensvalor_total.BeforeLoadDFMValues;
  cdsItensproduto_nome.BeforeLoadDFMValues;
  cdsItensprodnome.BeforeLoadDFMValues;
  cdsItensprodcodigo_interno.BeforeLoadDFMValues;
  cdsItensunidadesigla.BeforeLoadDFMValues;
  dtsItens.BeforeLoadDFMValues;
  tmrConsultaItens.BeforeLoadDFMValues;
  cdsRecebimentos.BeforeLoadDFMValues;
  cdsRecebimentosvalor_bruto_recebido.BeforeLoadDFMValues;
  cdsRecebimentosdata_recebimento.BeforeLoadDFMValues;
  cdsRecebimentosmodalidadenome.BeforeLoadDFMValues;
  cdsRecebimentosareceberdocumento.BeforeLoadDFMValues;
  cdsRecebimentosareceberparcela.BeforeLoadDFMValues;
  dtsRecebimentos.BeforeLoadDFMValues;
  dtsAReceber.BeforeLoadDFMValues;
  cdsAReceber.BeforeLoadDFMValues;
  cdsAReceberdocumento.BeforeLoadDFMValues;
  cdsAReceberparcela.BeforeLoadDFMValues;
  cdsAReceberemissao.BeforeLoadDFMValues;
  cdsARecebervencimento.BeforeLoadDFMValues;
  cdsARecebervalor_total.BeforeLoadDFMValues;
  cdsARecebervalor_saldo_pendente.BeforeLoadDFMValues;
  cdsARecebervalor_pago.BeforeLoadDFMValues;
  try
    Name := 'FViewCuponsEdit';
    Width := 944;
    Height := 535;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 24;
    lbid.Width := 70;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Servidor:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbcliente_id.SetParentComponent(Self);
    lbcliente_id.Name := 'lbcliente_id';
    lbcliente_id.Left := 8;
    lbcliente_id.Top := 51;
    lbcliente_id.Width := 37;
    lbcliente_id.Height := 13;
    lbcliente_id.Caption := 'Cliente:';
    lbcliente_id.HeightPercent := 100.000000000000000000;
    lbcliente_id.WidthPercent := 100.000000000000000000;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 8;
    lbfuncionario_id.Top := 78;
    lbfuncionario_id.Width := 59;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'Funcion'#225'rio:';
    lbfuncionario_id.HeightPercent := 100.000000000000000000;
    lbfuncionario_id.WidthPercent := 100.000000000000000000;
    lbcaixa.SetParentComponent(Self);
    lbcaixa.Name := 'lbcaixa';
    lbcaixa.Left := 8;
    lbcaixa.Top := 105;
    lbcaixa.Width := 31;
    lbcaixa.Height := 13;
    lbcaixa.Caption := 'Caixa:';
    lbcaixa.HeightPercent := 100.000000000000000000;
    lbcaixa.WidthPercent := 100.000000000000000000;
    lbnumero.SetParentComponent(Self);
    lbnumero.Name := 'lbnumero';
    lbnumero.Left := 8;
    lbnumero.Top := 132;
    lbnumero.Width := 58;
    lbnumero.Height := 13;
    lbnumero.Caption := 'Documento:';
    lbnumero.HeightPercent := 100.000000000000000000;
    lbnumero.WidthPercent := 100.000000000000000000;
    lbdoc_auxiliar.SetParentComponent(Self);
    lbdoc_auxiliar.Name := 'lbdoc_auxiliar';
    lbdoc_auxiliar.Left := 8;
    lbdoc_auxiliar.Top := 159;
    lbdoc_auxiliar.Width := 64;
    lbdoc_auxiliar.Height := 13;
    lbdoc_auxiliar.Caption := 'Doc. Auxiliar:';
    lbdoc_auxiliar.HeightPercent := 100.000000000000000000;
    lbdoc_auxiliar.WidthPercent := 100.000000000000000000;
    lbcoo.SetParentComponent(Self);
    lbcoo.Name := 'lbcoo';
    lbcoo.Left := 8;
    lbcoo.Top := 186;
    lbcoo.Width := 27;
    lbcoo.Height := 13;
    lbcoo.Caption := 'COO:';
    lbcoo.HeightPercent := 100.000000000000000000;
    lbcoo.WidthPercent := 100.000000000000000000;
    lbmodelo.SetParentComponent(Self);
    lbmodelo.Name := 'lbmodelo';
    lbmodelo.Left := 8;
    lbmodelo.Top := 213;
    lbmodelo.Width := 38;
    lbmodelo.Height := 13;
    lbmodelo.Caption := 'Modelo:';
    lbmodelo.HeightPercent := 100.000000000000000000;
    lbmodelo.WidthPercent := 100.000000000000000000;
    lbdata_emissao.SetParentComponent(Self);
    lbdata_emissao.Name := 'lbdata_emissao';
    lbdata_emissao.Left := 8;
    lbdata_emissao.Top := 240;
    lbdata_emissao.Width := 42;
    lbdata_emissao.Height := 13;
    lbdata_emissao.Caption := 'Emiss'#227'o:';
    lbdata_emissao.HeightPercent := 100.000000000000000000;
    lbdata_emissao.WidthPercent := 100.000000000000000000;
    lbdata_saida.SetParentComponent(Self);
    lbdata_saida.Name := 'lbdata_saida';
    lbdata_saida.Left := 8;
    lbdata_saida.Top := 267;
    lbdata_saida.Width := 30;
    lbdata_saida.Height := 13;
    lbdata_saida.Caption := 'Sa'#237'da:';
    lbdata_saida.HeightPercent := 100.000000000000000000;
    lbdata_saida.WidthPercent := 100.000000000000000000;
    lbvalor_acrescimos.SetParentComponent(Self);
    lbvalor_acrescimos.Name := 'lbvalor_acrescimos';
    lbvalor_acrescimos.Left := 8;
    lbvalor_acrescimos.Top := 294;
    lbvalor_acrescimos.Width := 57;
    lbvalor_acrescimos.Height := 13;
    lbvalor_acrescimos.Caption := 'Acr'#233'scimos:';
    lbvalor_acrescimos.HeightPercent := 100.000000000000000000;
    lbvalor_acrescimos.WidthPercent := 100.000000000000000000;
    lbvalor_descontos.SetParentComponent(Self);
    lbvalor_descontos.Name := 'lbvalor_descontos';
    lbvalor_descontos.Left := 8;
    lbvalor_descontos.Top := 321;
    lbvalor_descontos.Width := 54;
    lbvalor_descontos.Height := 13;
    lbvalor_descontos.Caption := 'Descontos:';
    lbvalor_descontos.HeightPercent := 100.000000000000000000;
    lbvalor_descontos.WidthPercent := 100.000000000000000000;
    lbvalor_base_calculo_icms.SetParentComponent(Self);
    lbvalor_base_calculo_icms.Name := 'lbvalor_base_calculo_icms';
    lbvalor_base_calculo_icms.Left := 232;
    lbvalor_base_calculo_icms.Top := 24;
    lbvalor_base_calculo_icms.Width := 55;
    lbvalor_base_calculo_icms.Height := 13;
    lbvalor_base_calculo_icms.Caption := 'Base ICMS:';
    lbvalor_base_calculo_icms.HeightPercent := 100.000000000000000000;
    lbvalor_base_calculo_icms.WidthPercent := 100.000000000000000000;
    lbvalor_icms.SetParentComponent(Self);
    lbvalor_icms.Name := 'lbvalor_icms';
    lbvalor_icms.Left := 232;
    lbvalor_icms.Top := 51;
    lbvalor_icms.Width := 56;
    lbvalor_icms.Height := 13;
    lbvalor_icms.Caption := 'Valor ICMS:';
    lbvalor_icms.HeightPercent := 100.000000000000000000;
    lbvalor_icms.WidthPercent := 100.000000000000000000;
    lbvalor_total_itens.SetParentComponent(Self);
    lbvalor_total_itens.Name := 'lbvalor_total_itens';
    lbvalor_total_itens.Left := 232;
    lbvalor_total_itens.Top := 78;
    lbvalor_total_itens.Width := 56;
    lbvalor_total_itens.Height := 13;
    lbvalor_total_itens.Caption := 'Total Itens:';
    lbvalor_total_itens.HeightPercent := 100.000000000000000000;
    lbvalor_total_itens.WidthPercent := 100.000000000000000000;
    lbvalor_total.SetParentComponent(Self);
    lbvalor_total.Name := 'lbvalor_total';
    lbvalor_total.Left := 232;
    lbvalor_total.Top := 105;
    lbvalor_total.Width := 28;
    lbvalor_total.Height := 13;
    lbvalor_total.Caption := 'Total:';
    lbvalor_total.HeightPercent := 100.000000000000000000;
    lbvalor_total.WidthPercent := 100.000000000000000000;
    lbcodigo_venda_conciliada.SetParentComponent(Self);
    lbcodigo_venda_conciliada.Name := 'lbcodigo_venda_conciliada';
    lbcodigo_venda_conciliada.Left := 232;
    lbcodigo_venda_conciliada.Top := 159;
    lbcodigo_venda_conciliada.Width := 91;
    lbcodigo_venda_conciliada.Height := 13;
    lbcodigo_venda_conciliada.Caption := 'C'#243'd. Venda Conc.:';
    lbcodigo_venda_conciliada.HeightPercent := 100.000000000000000000;
    lbcodigo_venda_conciliada.WidthPercent := 100.000000000000000000;
    lbobservacoes.SetParentComponent(Self);
    lbobservacoes.Name := 'lbobservacoes';
    lbobservacoes.Left := 232;
    lbobservacoes.Top := 186;
    lbobservacoes.Width := 67;
    lbobservacoes.Height := 13;
    lbobservacoes.Caption := 'Observa'#231#245'es:';
    lbobservacoes.HeightPercent := 100.000000000000000000;
    lbobservacoes.WidthPercent := 100.000000000000000000;
    lbdata_movimento.SetParentComponent(Self);
    lbdata_movimento.Name := 'lbdata_movimento';
    lbdata_movimento.Left := 232;
    lbdata_movimento.Top := 213;
    lbdata_movimento.Width := 82;
    lbdata_movimento.Height := 13;
    lbdata_movimento.Caption := 'Data Movimento:';
    lbdata_movimento.HeightPercent := 100.000000000000000000;
    lbdata_movimento.WidthPercent := 100.000000000000000000;
    lbsinc_scanntech.SetParentComponent(Self);
    lbsinc_scanntech.Name := 'lbsinc_scanntech';
    lbsinc_scanntech.Left := 232;
    lbsinc_scanntech.Top := 240;
    lbsinc_scanntech.Width := 80;
    lbsinc_scanntech.Height := 13;
    lbsinc_scanntech.Caption := 'Sinc. Scanntech:';
    lbsinc_scanntech.HeightPercent := 100.000000000000000000;
    lbsinc_scanntech.WidthPercent := 100.000000000000000000;
    lbvalor_desconto_scanntech.SetParentComponent(Self);
    lbvalor_desconto_scanntech.Name := 'lbvalor_desconto_scanntech';
    lbvalor_desconto_scanntech.Left := 232;
    lbvalor_desconto_scanntech.Top := 267;
    lbvalor_desconto_scanntech.Width := 102;
    lbvalor_desconto_scanntech.Height := 13;
    lbvalor_desconto_scanntech.Caption := 'Desconto Scanntech:';
    lbvalor_desconto_scanntech.HeightPercent := 100.000000000000000000;
    lbvalor_desconto_scanntech.WidthPercent := 100.000000000000000000;
    lbexcluiu_icms_base_pis_cofins.SetParentComponent(Self);
    lbexcluiu_icms_base_pis_cofins.Name := 'lbexcluiu_icms_base_pis_cofins';
    lbexcluiu_icms_base_pis_cofins.Left := 232;
    lbexcluiu_icms_base_pis_cofins.Top := 294;
    lbexcluiu_icms_base_pis_cofins.Width := 141;
    lbexcluiu_icms_base_pis_cofins.Height := 13;
    lbexcluiu_icms_base_pis_cofins.Caption := 'Excluiu ICMS Base Pis Cofins?';
    lbexcluiu_icms_base_pis_cofins.HeightPercent := 100.000000000000000000;
    lbexcluiu_icms_base_pis_cofins.WidthPercent := 100.000000000000000000;
    lbexcluiu_fcp_base_pis_cofins.SetParentComponent(Self);
    lbexcluiu_fcp_base_pis_cofins.Name := 'lbexcluiu_fcp_base_pis_cofins';
    lbexcluiu_fcp_base_pis_cofins.Left := 232;
    lbexcluiu_fcp_base_pis_cofins.Top := 321;
    lbexcluiu_fcp_base_pis_cofins.Width := 135;
    lbexcluiu_fcp_base_pis_cofins.Height := 13;
    lbexcluiu_fcp_base_pis_cofins.Caption := 'Excluiu FCP Base Pis Cofins?';
    lbexcluiu_fcp_base_pis_cofins.HeightPercent := 100.000000000000000000;
    lbexcluiu_fcp_base_pis_cofins.WidthPercent := 100.000000000000000000;
    lbcupom_cancelado.SetParentComponent(Self);
    lbcupom_cancelado.Name := 'lbcupom_cancelado';
    lbcupom_cancelado.Left := 527;
    lbcupom_cancelado.Top := 24;
    lbcupom_cancelado.Width := 91;
    lbcupom_cancelado.Height := 13;
    lbcupom_cancelado.Caption := 'Cupom Cancelado?';
    lbcupom_cancelado.HeightPercent := 100.000000000000000000;
    lbcupom_cancelado.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 527;
    lbcodigo_interno.Top := 51;
    lbcodigo_interno.Width := 87;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Retaguarda:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 527;
    lbexcluido.Top := 78;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 527;
    lbinclusao.Top := 105;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 527;
    lbalteracao.Top := 132;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 231;
    lbexclusao.Top := 132;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbPaginationInfoItens.SetParentComponent(Self);
    lbPaginationInfoItens.Name := 'lbPaginationInfoItens';
    lbPaginationInfoItens.Left := 8;
    lbPaginationInfoItens.Top := 511;
    lbPaginationInfoItens.Width := 141;
    lbPaginationInfoItens.Height := 13;
    lbPaginationInfoItens.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoItens.HeightPercent := 100.000000000000000000;
    lbPaginationInfoItens.WidthPercent := 100.000000000000000000;
    lbPaginationInfoAReceber.SetParentComponent(Self);
    lbPaginationInfoAReceber.Name := 'lbPaginationInfoAReceber';
    lbPaginationInfoAReceber.Left := 239;
    lbPaginationInfoAReceber.Top := 511;
    lbPaginationInfoAReceber.Width := 141;
    lbPaginationInfoAReceber.Height := 13;
    lbPaginationInfoAReceber.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoAReceber.Color := clBtnFace;
    lbPaginationInfoAReceber.HeightPercent := 100.000000000000000000;
    lbPaginationInfoAReceber.WidthPercent := 100.000000000000000000;
    lbPaginationInfoRecebimentos.SetParentComponent(Self);
    lbPaginationInfoRecebimentos.Name := 'lbPaginationInfoRecebimentos';
    lbPaginationInfoRecebimentos.Left := 481;
    lbPaginationInfoRecebimentos.Top := 511;
    lbPaginationInfoRecebimentos.Width := 141;
    lbPaginationInfoRecebimentos.Height := 13;
    lbPaginationInfoRecebimentos.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoRecebimentos.Color := clBtnFace;
    lbPaginationInfoRecebimentos.HeightPercent := 100.000000000000000000;
    lbPaginationInfoRecebimentos.WidthPercent := 100.000000000000000000;
    lbchave_acesso.SetParentComponent(Self);
    lbchave_acesso.Name := 'lbchave_acesso';
    lbchave_acesso.Left := 712;
    lbchave_acesso.Top := 374;
    lbchave_acesso.Width := 87;
    lbchave_acesso.Height := 13;
    lbchave_acesso.Caption := 'Chave de Acesso:';
    lbchave_acesso.HeightPercent := 100.000000000000000000;
    lbchave_acesso.WidthPercent := 100.000000000000000000;
    lbnfce_transmissao.SetParentComponent(Self);
    lbnfce_transmissao.Name := 'lbnfce_transmissao';
    lbnfce_transmissao.Left := 712;
    lbnfce_transmissao.Top := 400;
    lbnfce_transmissao.Width := 89;
    lbnfce_transmissao.Height := 13;
    lbnfce_transmissao.Caption := 'Data Transmiss'#227'o:';
    lbnfce_transmissao.HeightPercent := 100.000000000000000000;
    lbnfce_transmissao.WidthPercent := 100.000000000000000000;
    lbnfce_cancelada.SetParentComponent(Self);
    lbnfce_cancelada.Name := 'lbnfce_cancelada';
    lbnfce_cancelada.Left := 712;
    lbnfce_cancelada.Top := 430;
    lbnfce_cancelada.Width := 84;
    lbnfce_cancelada.Height := 13;
    lbnfce_cancelada.Caption := 'NFCe Cancelada?';
    lbnfce_cancelada.HeightPercent := 100.000000000000000000;
    lbnfce_cancelada.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 522;
    btCancel.Top := 174;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 109;
    edid.Top := 21;
    edid.Width := 100;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edcliente_id.SetParentComponent(Self);
    edcliente_id.Name := 'edcliente_id';
    edcliente_id.Left := 109;
    edcliente_id.Top := 48;
    edcliente_id.Width := 100;
    edcliente_id.Height := 21;
    edcliente_id.Enabled := False;
    edcliente_id.HeightPercent := 100.000000000000000000;
    edcliente_id.TabOrder := 9;
    edcliente_id.Text := 'edcliente_id';
    edcliente_id.WidthPercent := 100.000000000000000000;
    edcliente_id.DataField := 'cliente.razao_social_nome';
    edcliente_id.DataSource := DataSource;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 109;
    edfuncionario_id.Top := 75;
    edfuncionario_id.Width := 100;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := False;
    edfuncionario_id.HeightPercent := 100.000000000000000000;
    edfuncionario_id.TabOrder := 10;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.WidthPercent := 100.000000000000000000;
    edfuncionario_id.DataField := 'funcionario.nome';
    edfuncionario_id.DataSource := DataSource;
    edcaixa.SetParentComponent(Self);
    edcaixa.Name := 'edcaixa';
    edcaixa.Left := 109;
    edcaixa.Top := 102;
    edcaixa.Width := 100;
    edcaixa.Height := 21;
    edcaixa.Enabled := False;
    edcaixa.HeightPercent := 100.000000000000000000;
    edcaixa.TabOrder := 11;
    edcaixa.Text := 'edcaixa';
    edcaixa.WidthPercent := 100.000000000000000000;
    edcaixa.DataField := 'caixa';
    edcaixa.DataSource := DataSource;
    ednumero.SetParentComponent(Self);
    ednumero.Name := 'ednumero';
    ednumero.Left := 109;
    ednumero.Top := 129;
    ednumero.Width := 100;
    ednumero.Height := 21;
    ednumero.Enabled := False;
    ednumero.HeightPercent := 100.000000000000000000;
    ednumero.TabOrder := 12;
    ednumero.Text := 'ednumero';
    ednumero.WidthPercent := 100.000000000000000000;
    ednumero.DataField := 'numero';
    ednumero.DataSource := DataSource;
    eddoc_auxiliar.SetParentComponent(Self);
    eddoc_auxiliar.Name := 'eddoc_auxiliar';
    eddoc_auxiliar.Left := 109;
    eddoc_auxiliar.Top := 156;
    eddoc_auxiliar.Width := 100;
    eddoc_auxiliar.Height := 21;
    eddoc_auxiliar.Enabled := False;
    eddoc_auxiliar.HeightPercent := 100.000000000000000000;
    eddoc_auxiliar.TabOrder := 13;
    eddoc_auxiliar.Text := 'eddoc_auxiliar';
    eddoc_auxiliar.WidthPercent := 100.000000000000000000;
    eddoc_auxiliar.DataField := 'doc_auxiliar';
    eddoc_auxiliar.DataSource := DataSource;
    edcoo.SetParentComponent(Self);
    edcoo.Name := 'edcoo';
    edcoo.Left := 109;
    edcoo.Top := 183;
    edcoo.Width := 100;
    edcoo.Height := 21;
    edcoo.Enabled := False;
    edcoo.HeightPercent := 100.000000000000000000;
    edcoo.TabOrder := 14;
    edcoo.Text := 'edcoo';
    edcoo.WidthPercent := 100.000000000000000000;
    edcoo.DataField := 'coo';
    edcoo.DataSource := DataSource;
    edmodelo.SetParentComponent(Self);
    edmodelo.Name := 'edmodelo';
    edmodelo.Left := 109;
    edmodelo.Top := 210;
    edmodelo.Width := 100;
    edmodelo.Height := 21;
    edmodelo.Enabled := False;
    edmodelo.HeightPercent := 100.000000000000000000;
    edmodelo.TabOrder := 15;
    edmodelo.Text := 'edmodelo';
    edmodelo.WidthPercent := 100.000000000000000000;
    edmodelo.DataField := 'modelo';
    edmodelo.DataSource := DataSource;
    eddata_emissao.SetParentComponent(Self);
    eddata_emissao.Name := 'eddata_emissao';
    eddata_emissao.Left := 109;
    eddata_emissao.Top := 237;
    eddata_emissao.Width := 100;
    eddata_emissao.Height := 21;
    eddata_emissao.Enabled := False;
    eddata_emissao.HeightPercent := 100.000000000000000000;
    eddata_emissao.TabOrder := 16;
    eddata_emissao.Text := 'eddata_emissao';
    eddata_emissao.WidthPercent := 100.000000000000000000;
    eddata_emissao.DataField := 'data_emissao';
    eddata_emissao.DataSource := DataSource;
    eddata_saida.SetParentComponent(Self);
    eddata_saida.Name := 'eddata_saida';
    eddata_saida.Left := 109;
    eddata_saida.Top := 264;
    eddata_saida.Width := 100;
    eddata_saida.Height := 21;
    eddata_saida.Enabled := False;
    eddata_saida.HeightPercent := 100.000000000000000000;
    eddata_saida.TabOrder := 17;
    eddata_saida.Text := 'eddata_saida';
    eddata_saida.WidthPercent := 100.000000000000000000;
    eddata_saida.DataField := 'data_saida';
    eddata_saida.DataSource := DataSource;
    edvalor_acrescimos.SetParentComponent(Self);
    edvalor_acrescimos.Name := 'edvalor_acrescimos';
    edvalor_acrescimos.Left := 109;
    edvalor_acrescimos.Top := 291;
    edvalor_acrescimos.Width := 100;
    edvalor_acrescimos.Height := 21;
    edvalor_acrescimos.Enabled := False;
    edvalor_acrescimos.HeightPercent := 100.000000000000000000;
    edvalor_acrescimos.TabOrder := 18;
    edvalor_acrescimos.Text := 'edvalor_acrescimos';
    edvalor_acrescimos.WidthPercent := 100.000000000000000000;
    edvalor_acrescimos.DataField := 'valor_acrescimos';
    edvalor_acrescimos.DataSource := DataSource;
    edvalor_descontos.SetParentComponent(Self);
    edvalor_descontos.Name := 'edvalor_descontos';
    edvalor_descontos.Left := 109;
    edvalor_descontos.Top := 318;
    edvalor_descontos.Width := 100;
    edvalor_descontos.Height := 21;
    edvalor_descontos.Enabled := False;
    edvalor_descontos.HeightPercent := 100.000000000000000000;
    edvalor_descontos.TabOrder := 19;
    edvalor_descontos.Text := 'edvalor_descontos';
    edvalor_descontos.WidthPercent := 100.000000000000000000;
    edvalor_descontos.DataField := 'valor_descontos';
    edvalor_descontos.DataSource := DataSource;
    edvalor_base_calculo_icms.SetParentComponent(Self);
    edvalor_base_calculo_icms.Name := 'edvalor_base_calculo_icms';
    edvalor_base_calculo_icms.Left := 405;
    edvalor_base_calculo_icms.Top := 21;
    edvalor_base_calculo_icms.Width := 100;
    edvalor_base_calculo_icms.Height := 21;
    edvalor_base_calculo_icms.Enabled := False;
    edvalor_base_calculo_icms.HeightPercent := 100.000000000000000000;
    edvalor_base_calculo_icms.TabOrder := 20;
    edvalor_base_calculo_icms.Text := 'edvalor_base_calculo_icms';
    edvalor_base_calculo_icms.WidthPercent := 100.000000000000000000;
    edvalor_base_calculo_icms.DataField := 'valor_base_calculo_icms';
    edvalor_base_calculo_icms.DataSource := DataSource;
    edvalor_icms.SetParentComponent(Self);
    edvalor_icms.Name := 'edvalor_icms';
    edvalor_icms.Left := 405;
    edvalor_icms.Top := 48;
    edvalor_icms.Width := 100;
    edvalor_icms.Height := 21;
    edvalor_icms.Enabled := False;
    edvalor_icms.HeightPercent := 100.000000000000000000;
    edvalor_icms.TabOrder := 21;
    edvalor_icms.Text := 'edvalor_icms';
    edvalor_icms.WidthPercent := 100.000000000000000000;
    edvalor_icms.DataField := 'valor_icms';
    edvalor_icms.DataSource := DataSource;
    edvalor_total_itens.SetParentComponent(Self);
    edvalor_total_itens.Name := 'edvalor_total_itens';
    edvalor_total_itens.Left := 405;
    edvalor_total_itens.Top := 75;
    edvalor_total_itens.Width := 100;
    edvalor_total_itens.Height := 21;
    edvalor_total_itens.Enabled := False;
    edvalor_total_itens.HeightPercent := 100.000000000000000000;
    edvalor_total_itens.TabOrder := 22;
    edvalor_total_itens.Text := 'edvalor_total_itens';
    edvalor_total_itens.WidthPercent := 100.000000000000000000;
    edvalor_total_itens.DataField := 'valor_total_itens';
    edvalor_total_itens.DataSource := DataSource;
    edvalor_total.SetParentComponent(Self);
    edvalor_total.Name := 'edvalor_total';
    edvalor_total.Left := 405;
    edvalor_total.Top := 102;
    edvalor_total.Width := 100;
    edvalor_total.Height := 21;
    edvalor_total.Enabled := False;
    edvalor_total.HeightPercent := 100.000000000000000000;
    edvalor_total.TabOrder := 23;
    edvalor_total.Text := 'edvalor_total';
    edvalor_total.WidthPercent := 100.000000000000000000;
    edvalor_total.DataField := 'valor_total';
    edvalor_total.DataSource := DataSource;
    edcodigo_venda_conciliada.SetParentComponent(Self);
    edcodigo_venda_conciliada.Name := 'edcodigo_venda_conciliada';
    edcodigo_venda_conciliada.Left := 405;
    edcodigo_venda_conciliada.Top := 156;
    edcodigo_venda_conciliada.Width := 100;
    edcodigo_venda_conciliada.Height := 21;
    edcodigo_venda_conciliada.Enabled := False;
    edcodigo_venda_conciliada.HeightPercent := 100.000000000000000000;
    edcodigo_venda_conciliada.TabOrder := 25;
    edcodigo_venda_conciliada.Text := 'edcodigo_venda_conciliada';
    edcodigo_venda_conciliada.WidthPercent := 100.000000000000000000;
    edcodigo_venda_conciliada.DataField := 'codigo_venda_conciliada';
    edcodigo_venda_conciliada.DataSource := DataSource;
    edobservacoes.SetParentComponent(Self);
    edobservacoes.Name := 'edobservacoes';
    edobservacoes.Left := 405;
    edobservacoes.Top := 183;
    edobservacoes.Width := 100;
    edobservacoes.Height := 21;
    edobservacoes.Enabled := False;
    edobservacoes.HeightPercent := 100.000000000000000000;
    edobservacoes.TabOrder := 30;
    edobservacoes.Text := 'edobservacoes';
    edobservacoes.WidthPercent := 100.000000000000000000;
    edobservacoes.DataField := 'observacoes';
    edobservacoes.DataSource := DataSource;
    eddata_movimento.SetParentComponent(Self);
    eddata_movimento.Name := 'eddata_movimento';
    eddata_movimento.Left := 405;
    eddata_movimento.Top := 210;
    eddata_movimento.Width := 100;
    eddata_movimento.Height := 21;
    eddata_movimento.Enabled := False;
    eddata_movimento.HeightPercent := 100.000000000000000000;
    eddata_movimento.TabOrder := 33;
    eddata_movimento.Text := 'eddata_movimento';
    eddata_movimento.WidthPercent := 100.000000000000000000;
    eddata_movimento.DataField := 'data_movimento';
    eddata_movimento.DataSource := DataSource;
    edsinc_scanntech.SetParentComponent(Self);
    edsinc_scanntech.Name := 'edsinc_scanntech';
    edsinc_scanntech.Left := 405;
    edsinc_scanntech.Top := 237;
    edsinc_scanntech.Width := 100;
    edsinc_scanntech.Height := 21;
    edsinc_scanntech.Enabled := False;
    edsinc_scanntech.HeightPercent := 100.000000000000000000;
    edsinc_scanntech.TabOrder := 36;
    edsinc_scanntech.Text := 'edsinc_scanntech';
    edsinc_scanntech.WidthPercent := 100.000000000000000000;
    edsinc_scanntech.DataField := 'sinc_scanntech';
    edsinc_scanntech.DataSource := DataSource;
    edvalor_desconto_scanntech.SetParentComponent(Self);
    edvalor_desconto_scanntech.Name := 'edvalor_desconto_scanntech';
    edvalor_desconto_scanntech.Left := 405;
    edvalor_desconto_scanntech.Top := 264;
    edvalor_desconto_scanntech.Width := 100;
    edvalor_desconto_scanntech.Height := 21;
    edvalor_desconto_scanntech.Enabled := False;
    edvalor_desconto_scanntech.HeightPercent := 100.000000000000000000;
    edvalor_desconto_scanntech.TabOrder := 37;
    edvalor_desconto_scanntech.Text := 'edvalor_desconto_scanntech';
    edvalor_desconto_scanntech.WidthPercent := 100.000000000000000000;
    edvalor_desconto_scanntech.DataField := 'valor_desconto_scanntech';
    edvalor_desconto_scanntech.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 639;
    edcodigo_interno.Top := 48;
    edcodigo_interno.Width := 100;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 42;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 639;
    edinclusao.Top := 102;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 44;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 639;
    edalteracao.Top := 129;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 45;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 407;
    edexclusao.Top := 129;
    edexclusao.Width := 100;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 46;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    pnlFormDados.SetParentComponent(Self);
    pnlFormDados.Name := 'pnlFormDados';
    pnlFormDados.Left := 8;
    pnlFormDados.Top := 2;
    pnlFormDados.Width := 928;
    pnlFormDados.Height := 17;
    pnlFormDados.Caption := 'Espa'#231'o Form Dados';
    pnlFormDados.ChildOrder := 23;
    pnlFormDados.Color := clInfoText;
    pnlFormDados.Font.Charset := DEFAULT_CHARSET;
    pnlFormDados.Font.Color := clWhite;
    pnlFormDados.Font.Height := -11;
    pnlFormDados.Font.Name := 'Tahoma';
    pnlFormDados.Font.Style := [fsBold];
    pnlFormDados.ParentFont := False;
    pnlFormDados.TabOrder := 26;
    pnlFormDados.Visible := False;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 639;
    cbxexcluido.Top := 75;
    cbxexcluido.Width := 100;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxexcluiu_icms_base_pis_cofins.SetParentComponent(Self);
    cbxexcluiu_icms_base_pis_cofins.Name := 'cbxexcluiu_icms_base_pis_cofins';
    cbxexcluiu_icms_base_pis_cofins.Left := 405;
    cbxexcluiu_icms_base_pis_cofins.Top := 290;
    cbxexcluiu_icms_base_pis_cofins.Width := 100;
    cbxexcluiu_icms_base_pis_cofins.Height := 22;
    cbxexcluiu_icms_base_pis_cofins.Caption := 'cbxexcluiu_icms_base_pis_cofins';
    cbxexcluiu_icms_base_pis_cofins.ChildOrder := 33;
    cbxexcluiu_icms_base_pis_cofins.Enabled := False;
    cbxexcluiu_icms_base_pis_cofins.HeightPercent := 100.000000000000000000;
    cbxexcluiu_icms_base_pis_cofins.WidthPercent := 100.000000000000000000;
    cbxexcluiu_icms_base_pis_cofins.DataField := 'excluiu_icms_base_pis_cofins';
    cbxexcluiu_icms_base_pis_cofins.DataSource := DataSource;
    cbxexcluiu_fcp_base_pis_cofins.SetParentComponent(Self);
    cbxexcluiu_fcp_base_pis_cofins.Name := 'cbxexcluiu_fcp_base_pis_cofins';
    cbxexcluiu_fcp_base_pis_cofins.Left := 407;
    cbxexcluiu_fcp_base_pis_cofins.Top := 318;
    cbxexcluiu_fcp_base_pis_cofins.Width := 100;
    cbxexcluiu_fcp_base_pis_cofins.Height := 22;
    cbxexcluiu_fcp_base_pis_cofins.Caption := 'cbxexcluiu_fcp_base_pis_cofins';
    cbxexcluiu_fcp_base_pis_cofins.ChildOrder := 33;
    cbxexcluiu_fcp_base_pis_cofins.Enabled := False;
    cbxexcluiu_fcp_base_pis_cofins.HeightPercent := 100.000000000000000000;
    cbxexcluiu_fcp_base_pis_cofins.WidthPercent := 100.000000000000000000;
    cbxexcluiu_fcp_base_pis_cofins.DataField := 'excluiu_fcp_base_pis_cofins';
    cbxexcluiu_fcp_base_pis_cofins.DataSource := DataSource;
    cbxcupom_cancelado.SetParentComponent(Self);
    cbxcupom_cancelado.Name := 'cbxcupom_cancelado';
    cbxcupom_cancelado.Left := 639;
    cbxcupom_cancelado.Top := 20;
    cbxcupom_cancelado.Width := 100;
    cbxcupom_cancelado.Height := 22;
    cbxcupom_cancelado.Caption := 'cbxcupom_cancelado';
    cbxcupom_cancelado.ChildOrder := 33;
    cbxcupom_cancelado.Enabled := False;
    cbxcupom_cancelado.HeightPercent := 100.000000000000000000;
    cbxcupom_cancelado.WidthPercent := 100.000000000000000000;
    cbxcupom_cancelado.DataField := 'cupom_cancelado';
    cbxcupom_cancelado.DataSource := DataSource;
    tblItens.SetParentComponent(Self);
    tblItens.Name := 'tblItens';
    tblItens.Left := 8;
    tblItens.Top := 403;
    tblItens.Width := 225;
    tblItens.Height := 102;
    tblItens.ElementClassName := 'table-responsive';
    tblItens.BorderColor := clSilver;
    tblItens.ChildOrder := 28;
    tblItens.ColHeader := False;
    tblItens.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblItens, Self, 'OnGetCellClass', 'tblItensGetCellClass');
    tblItens.Columns.Clear;
    with tblItens.Columns.Add do
    begin
      DataField := 'item';
      Title := 'item';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'prod.codigo_interno';
      Title := 'C'#243'd. Produto';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'produto_nome';
      Title := 'Produto';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'unidade.sigla';
      Title := 'Unidade';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'produto_preco';
      Title := 'Pre'#231'o';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'quantidade';
      Title := 'quantidade';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Total';
    end;
    tblItens.DataSource := dtsItens;
    cbPageSizeItens.SetParentComponent(Self);
    cbPageSizeItens.Name := 'cbPageSizeItens';
    cbPageSizeItens.Left := 8;
    cbPageSizeItens.Top := 376;
    cbPageSizeItens.Width := 81;
    cbPageSizeItens.Height := 21;
    cbPageSizeItens.HeightPercent := 100.000000000000000000;
    cbPageSizeItens.TabOrder := 2;
    cbPageSizeItens.Text := '10';
    cbPageSizeItens.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeItens, Self, 'OnChange', 'cbPageSizeItensChange');
    cbPageSizeItens.ItemIndex := 0;
    cbPageSizeItens.Items.BeginUpdate;
    try
      cbPageSizeItens.Items.Clear;
      cbPageSizeItens.Items.Add('10');
      cbPageSizeItens.Items.Add('25');
      cbPageSizeItens.Items.Add('50');
      cbPageSizeItens.Items.Add('100');
    finally
      cbPageSizeItens.Items.EndUpdate;
    end;
    edSearchItens.SetParentComponent(Self);
    edSearchItens.Name := 'edSearchItens';
    edSearchItens.Left := 95;
    edSearchItens.Top := 376;
    edSearchItens.Width := 54;
    edSearchItens.Height := 21;
    edSearchItens.ChildOrder := 30;
    edSearchItens.HeightPercent := 100.000000000000000000;
    edSearchItens.TabOrder := 3;
    edSearchItens.WidthPercent := 100.000000000000000000;
    SetEvent(edSearchItens, Self, 'OnKeyDown', 'edSearchItensKeyDown');
    SetEvent(edSearchItens, Self, 'OnKeyUp', 'edSearchItensKeyUp');
    pnlItensPromocao.SetParentComponent(Self);
    pnlItensPromocao.Name := 'pnlItensPromocao';
    pnlItensPromocao.Left := 8;
    pnlItensPromocao.Top := 352;
    pnlItensPromocao.Width := 225;
    pnlItensPromocao.Height := 17;
    pnlItensPromocao.Caption := 'Espa'#231'o tabela Itens';
    pnlItensPromocao.ChildOrder := 23;
    pnlItensPromocao.Color := clInfoText;
    pnlItensPromocao.Font.Charset := DEFAULT_CHARSET;
    pnlItensPromocao.Font.Color := clWhite;
    pnlItensPromocao.Font.Height := -11;
    pnlItensPromocao.Font.Name := 'Tahoma';
    pnlItensPromocao.Font.Style := [fsBold];
    pnlItensPromocao.ParentFont := False;
    pnlItensPromocao.TabOrder := 34;
    pnlItensPromocao.Visible := False;
    btnItensTab.SetParentComponent(Self);
    btnItensTab.Name := 'btnItensTab';
    btnItensTab.Left := 155;
    btnItensTab.Top := 375;
    btnItensTab.Width := 78;
    btnItensTab.Height := 25;
    btnItensTab.Caption := 'Itens';
    btnItensTab.ChildOrder := 34;
    btnItensTab.HeightPercent := 100.000000000000000000;
    btnItensTab.TabOrder := 1;
    btnItensTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnItensTab, Self, 'OnClick', 'btnItensTabClick');
    lcPaginatorItens.SetParentComponent(Self);
    lcPaginatorItens.Name := 'lcPaginatorItens';
    lcPaginatorItens.Left := 112;
    lcPaginatorItens.Top := 511;
    lcPaginatorItens.Width := 121;
    lcPaginatorItens.Height := 13;
    lcPaginatorItens.HeightPercent := 100.000000000000000000;
    lcPaginatorItens.WidthPercent := 100.000000000000000000;
    lcPaginatorItens.ChildOrder := 132;
    lcPaginatorItens.DefaultItemClassName := 'page-item';
    lcPaginatorItens.DefaultItemLinkClassName := 'page-link';
    lcPaginatorItens.ElementListClassName := 'pagination';
    lcPaginatorItens.Items.Clear;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorItens.Style := lsPagination;
    pnlTabelaAReceber.SetParentComponent(Self);
    pnlTabelaAReceber.Name := 'pnlTabelaAReceber';
    pnlTabelaAReceber.Left := 239;
    pnlTabelaAReceber.Top := 352;
    pnlTabelaAReceber.Width := 225;
    pnlTabelaAReceber.Height := 17;
    pnlTabelaAReceber.Caption := 'Espa'#231'o AReceber';
    pnlTabelaAReceber.ChildOrder := 23;
    pnlTabelaAReceber.Color := clInfoText;
    pnlTabelaAReceber.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaAReceber.Font.Color := clWhite;
    pnlTabelaAReceber.Font.Height := -11;
    pnlTabelaAReceber.Font.Name := 'Tahoma';
    pnlTabelaAReceber.Font.Style := [fsBold];
    pnlTabelaAReceber.ParentFont := False;
    pnlTabelaAReceber.TabOrder := 37;
    pnlTabelaAReceber.Visible := False;
    tblAReceber.SetParentComponent(Self);
    tblAReceber.Name := 'tblAReceber';
    tblAReceber.Left := 239;
    tblAReceber.Top := 406;
    tblAReceber.Width := 225;
    tblAReceber.Height := 99;
    tblAReceber.ElementClassName := 'table-responsive';
    tblAReceber.BorderColor := clSilver;
    tblAReceber.ChildOrder := 82;
    tblAReceber.ColHeader := False;
    tblAReceber.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblAReceber, Self, 'OnGetCellData', 'tblAReceberGetCellData');
    SetEvent(tblAReceber, Self, 'OnGetCellClass', 'tblAReceberGetCellClass');
    tblAReceber.Columns.Clear;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'Doc./Parcela';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'Emiss'#227'o';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'vencimento';
      Title := 'Vencimento';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_saldo_pendente';
      Title := 'Saldo Pendente';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_pago';
      Title := 'Valor Pago';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Valor Total';
    end;
    tblAReceber.DataSource := dtsAReceber;
    lcPaginatorAReceber.SetParentComponent(Self);
    lcPaginatorAReceber.Name := 'lcPaginatorAReceber';
    lcPaginatorAReceber.Left := 362;
    lcPaginatorAReceber.Top := 511;
    lcPaginatorAReceber.Width := 102;
    lcPaginatorAReceber.Height := 15;
    lcPaginatorAReceber.HeightPercent := 100.000000000000000000;
    lcPaginatorAReceber.WidthPercent := 100.000000000000000000;
    lcPaginatorAReceber.ChildOrder := 81;
    lcPaginatorAReceber.DefaultItemClassName := 'page-item';
    lcPaginatorAReceber.DefaultItemLinkClassName := 'page-link';
    lcPaginatorAReceber.ElementListClassName := 'pagination';
    lcPaginatorAReceber.Items.Clear;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorAReceber.Style := lsPagination;
    tblRecebimentos.SetParentComponent(Self);
    tblRecebimentos.Name := 'tblRecebimentos';
    tblRecebimentos.Left := 481;
    tblRecebimentos.Top := 406;
    tblRecebimentos.Width := 225;
    tblRecebimentos.Height := 99;
    tblRecebimentos.ElementClassName := 'table-responsive';
    tblRecebimentos.BorderColor := clSilver;
    tblRecebimentos.ChildOrder := 82;
    tblRecebimentos.ColHeader := False;
    tblRecebimentos.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblRecebimentos, Self, 'OnGetCellClass', 'tblRecebimentosGetCellClass');
    tblRecebimentos.Columns.Clear;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'areceber.documento';
      Title := 'Doc./Parcela';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'modalidade.nome';
      Title := 'Modalidade';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'data_recebimento';
      Title := 'Data Recebimento';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'valor_bruto_recebido';
      Title := 'Valor';
    end;
    tblRecebimentos.DataSource := dtsRecebimentos;
    pnlTabelaPagamentos.SetParentComponent(Self);
    pnlTabelaPagamentos.Name := 'pnlTabelaPagamentos';
    pnlTabelaPagamentos.Left := 481;
    pnlTabelaPagamentos.Top := 352;
    pnlTabelaPagamentos.Width := 225;
    pnlTabelaPagamentos.Height := 17;
    pnlTabelaPagamentos.Caption := 'Espa'#231'o Pagamentos';
    pnlTabelaPagamentos.ChildOrder := 23;
    pnlTabelaPagamentos.Color := clInfoText;
    pnlTabelaPagamentos.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaPagamentos.Font.Color := clWhite;
    pnlTabelaPagamentos.Font.Height := -11;
    pnlTabelaPagamentos.Font.Name := 'Tahoma';
    pnlTabelaPagamentos.Font.Style := [fsBold];
    pnlTabelaPagamentos.ParentFont := False;
    pnlTabelaPagamentos.TabOrder := 41;
    pnlTabelaPagamentos.Visible := False;
    btnFinanceiroTab.SetParentComponent(Self);
    btnFinanceiroTab.Name := 'btnFinanceiroTab';
    btnFinanceiroTab.Left := 239;
    btnFinanceiroTab.Top := 375;
    btnFinanceiroTab.Width := 78;
    btnFinanceiroTab.Height := 25;
    btnFinanceiroTab.Caption := 'Financeiro';
    btnFinanceiroTab.ChildOrder := 34;
    btnFinanceiroTab.HeightPercent := 100.000000000000000000;
    btnFinanceiroTab.TabOrder := 1;
    btnFinanceiroTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnFinanceiroTab, Self, 'OnClick', 'btnFinanceiroTabClick');
    btnRecebimentosTab.SetParentComponent(Self);
    btnRecebimentosTab.Name := 'btnRecebimentosTab';
    btnRecebimentosTab.Left := 481;
    btnRecebimentosTab.Top := 375;
    btnRecebimentosTab.Width := 78;
    btnRecebimentosTab.Height := 25;
    btnRecebimentosTab.Caption := 'Recebimentos';
    btnRecebimentosTab.ChildOrder := 34;
    btnRecebimentosTab.HeightPercent := 100.000000000000000000;
    btnRecebimentosTab.TabOrder := 1;
    btnRecebimentosTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnRecebimentosTab, Self, 'OnClick', 'btnRecebimentosTabClick');
    lcPaginatorRecebimentos.SetParentComponent(Self);
    lcPaginatorRecebimentos.Name := 'lcPaginatorRecebimentos';
    lcPaginatorRecebimentos.Left := 604;
    lcPaginatorRecebimentos.Top := 509;
    lcPaginatorRecebimentos.Width := 102;
    lcPaginatorRecebimentos.Height := 15;
    lcPaginatorRecebimentos.HeightPercent := 100.000000000000000000;
    lcPaginatorRecebimentos.WidthPercent := 100.000000000000000000;
    lcPaginatorRecebimentos.ChildOrder := 81;
    lcPaginatorRecebimentos.DefaultItemClassName := 'page-item';
    lcPaginatorRecebimentos.DefaultItemLinkClassName := 'page-link';
    lcPaginatorRecebimentos.ElementListClassName := 'pagination';
    lcPaginatorRecebimentos.Items.Clear;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorRecebimentos.Style := lsPagination;
    pnlFormNfce.SetParentComponent(Self);
    pnlFormNfce.Name := 'pnlFormNfce';
    pnlFormNfce.Left := 712;
    pnlFormNfce.Top := 352;
    pnlFormNfce.Width := 225;
    pnlFormNfce.Height := 17;
    pnlFormNfce.Caption := 'Espa'#231'o NFCe';
    pnlFormNfce.ChildOrder := 23;
    pnlFormNfce.Color := clInfoText;
    pnlFormNfce.Font.Charset := DEFAULT_CHARSET;
    pnlFormNfce.Font.Color := clWhite;
    pnlFormNfce.Font.Height := -11;
    pnlFormNfce.Font.Name := 'Tahoma';
    pnlFormNfce.Font.Style := [fsBold];
    pnlFormNfce.ParentFont := False;
    pnlFormNfce.TabOrder := 45;
    pnlFormNfce.Visible := False;
    edchave_acesso.SetParentComponent(Self);
    edchave_acesso.Name := 'edchave_acesso';
    edchave_acesso.Left := 807;
    edchave_acesso.Top := 371;
    edchave_acesso.Width := 100;
    edchave_acesso.Height := 21;
    edchave_acesso.ChildOrder := 145;
    edchave_acesso.Enabled := False;
    edchave_acesso.HeightPercent := 100.000000000000000000;
    edchave_acesso.TabOrder := 28;
    edchave_acesso.Text := 'edchave_acesso';
    edchave_acesso.WidthPercent := 100.000000000000000000;
    edchave_acesso.DataField := 'nfce.chave_acesso';
    edchave_acesso.DataSource := DataSource;
    ednfce_transmissao.SetParentComponent(Self);
    ednfce_transmissao.Name := 'ednfce_transmissao';
    ednfce_transmissao.Left := 807;
    ednfce_transmissao.Top := 397;
    ednfce_transmissao.Width := 100;
    ednfce_transmissao.Height := 21;
    ednfce_transmissao.ChildOrder := 145;
    ednfce_transmissao.Enabled := False;
    ednfce_transmissao.HeightPercent := 100.000000000000000000;
    ednfce_transmissao.TabOrder := 28;
    ednfce_transmissao.Text := 'ednfce_transmissao';
    ednfce_transmissao.WidthPercent := 100.000000000000000000;
    ednfce_transmissao.DataField := 'nfce.data_transmissao';
    ednfce_transmissao.DataSource := DataSource;
    btnCopiarChaveAcesso.SetParentComponent(Self);
    btnCopiarChaveAcesso.Name := 'btnCopiarChaveAcesso';
    btnCopiarChaveAcesso.Left := 906;
    btnCopiarChaveAcesso.Top := 371;
    btnCopiarChaveAcesso.Width := 30;
    btnCopiarChaveAcesso.Height := 21;
    btnCopiarChaveAcesso.ChildOrder := 22;
    btnCopiarChaveAcesso.HeightPercent := 100.000000000000000000;
    btnCopiarChaveAcesso.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarChaveAcesso, Self, 'OnClick', 'btnCopiarChaveAcessoClick');
    btnNfceTab.SetParentComponent(Self);
    btnNfceTab.Name := 'btnNfceTab';
    btnNfceTab.Left := 712;
    btnNfceTab.Top := 480;
    btnNfceTab.Width := 78;
    btnNfceTab.Height := 25;
    btnNfceTab.Caption := 'NFCe';
    btnNfceTab.ChildOrder := 34;
    btnNfceTab.HeightPercent := 100.000000000000000000;
    btnNfceTab.TabOrder := 1;
    btnNfceTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnNfceTab, Self, 'OnClick', 'btnNfceTabClick');
    cbxnfce_cancelada.SetParentComponent(Self);
    cbxnfce_cancelada.Name := 'cbxnfce_cancelada';
    cbxnfce_cancelada.Left := 808;
    cbxnfce_cancelada.Top := 427;
    cbxnfce_cancelada.Width := 100;
    cbxnfce_cancelada.Height := 22;
    cbxnfce_cancelada.Caption := 'cbxnfce_cancelada';
    cbxnfce_cancelada.ChildOrder := 33;
    cbxnfce_cancelada.Enabled := False;
    cbxnfce_cancelada.HeightPercent := 100.000000000000000000;
    cbxnfce_cancelada.WidthPercent := 100.000000000000000000;
    cbxnfce_cancelada.DataField := 'nfce.nfce_cancelada';
    cbxnfce_cancelada.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := CuponsDataset;
    DataSource.Left := 800;
    DataSource.Top := 176;
    CuponsDataset.SetParentComponent(Self);
    CuponsDataset.Name := 'CuponsDataset';
    CuponsDataset.AfterApplyUpdates := CuponsDatasetAfterApplyUpdates;
    CuponsDataset.EntitySetName := 'Cupons';
    CuponsDataset.Connection := DMConnection.ApiConnection;
    CuponsDataset.Left := 544;
    CuponsDataset.Top := 216;
    CuponsDatasetid.SetParentComponent(CuponsDataset);
    CuponsDatasetid.Name := 'CuponsDatasetid';
    CuponsDatasetid.FieldName := 'id';
    CuponsDatasetid.Required := True;
    CuponsDatasetaliado_id.SetParentComponent(CuponsDataset);
    CuponsDatasetaliado_id.Name := 'CuponsDatasetaliado_id';
    CuponsDatasetaliado_id.FieldName := 'aliado_id';
    CuponsDatasetaliado_id.Required := True;
    CuponsDatasetdata_base_id.SetParentComponent(CuponsDataset);
    CuponsDatasetdata_base_id.Name := 'CuponsDatasetdata_base_id';
    CuponsDatasetdata_base_id.FieldName := 'data_base_id';
    CuponsDatasetdata_base_id.Required := True;
    CuponsDatasetcliente_id.SetParentComponent(CuponsDataset);
    CuponsDatasetcliente_id.Name := 'CuponsDatasetcliente_id';
    CuponsDatasetcliente_id.FieldName := 'cliente_id';
    CuponsDatasetcliente_id.Required := True;
    CuponsDatasetfuncionario_id.SetParentComponent(CuponsDataset);
    CuponsDatasetfuncionario_id.Name := 'CuponsDatasetfuncionario_id';
    CuponsDatasetfuncionario_id.FieldName := 'funcionario_id';
    CuponsDatasetcaixa.SetParentComponent(CuponsDataset);
    CuponsDatasetcaixa.Name := 'CuponsDatasetcaixa';
    CuponsDatasetcaixa.FieldName := 'caixa';
    CuponsDatasetnumero.SetParentComponent(CuponsDataset);
    CuponsDatasetnumero.Name := 'CuponsDatasetnumero';
    CuponsDatasetnumero.FieldName := 'numero';
    CuponsDatasetnumero.Required := True;
    CuponsDatasetnumero.Size := 255;
    CuponsDatasetdoc_auxiliar.SetParentComponent(CuponsDataset);
    CuponsDatasetdoc_auxiliar.Name := 'CuponsDatasetdoc_auxiliar';
    CuponsDatasetdoc_auxiliar.FieldName := 'doc_auxiliar';
    CuponsDatasetdoc_auxiliar.Size := 255;
    CuponsDatasetcoo.SetParentComponent(CuponsDataset);
    CuponsDatasetcoo.Name := 'CuponsDatasetcoo';
    CuponsDatasetcoo.FieldName := 'coo';
    CuponsDatasetcoo.Size := 255;
    CuponsDatasetmodelo.SetParentComponent(CuponsDataset);
    CuponsDatasetmodelo.Name := 'CuponsDatasetmodelo';
    CuponsDatasetmodelo.FieldName := 'modelo';
    CuponsDatasetmodelo.Size := 255;
    CuponsDatasetdata_emissao.SetParentComponent(CuponsDataset);
    CuponsDatasetdata_emissao.Name := 'CuponsDatasetdata_emissao';
    CuponsDatasetdata_emissao.FieldName := 'data_emissao';
    CuponsDatasetdata_emissao.Required := True;
    CuponsDatasetdata_emissao.DisplayFormat := 'dd/mm/yy';
    CuponsDatasetdata_saida.SetParentComponent(CuponsDataset);
    CuponsDatasetdata_saida.Name := 'CuponsDatasetdata_saida';
    CuponsDatasetdata_saida.FieldName := 'data_saida';
    CuponsDatasetdata_saida.DisplayFormat := 'dd/mm/yy';
    CuponsDatasetvalor_acrescimos.SetParentComponent(CuponsDataset);
    CuponsDatasetvalor_acrescimos.Name := 'CuponsDatasetvalor_acrescimos';
    CuponsDatasetvalor_acrescimos.FieldName := 'valor_acrescimos';
    CuponsDatasetvalor_acrescimos.DisplayFormat := '#,##0.00';
    CuponsDatasetvalor_descontos.SetParentComponent(CuponsDataset);
    CuponsDatasetvalor_descontos.Name := 'CuponsDatasetvalor_descontos';
    CuponsDatasetvalor_descontos.FieldName := 'valor_descontos';
    CuponsDatasetvalor_descontos.DisplayFormat := '#,##0.00';
    CuponsDatasetvalor_base_calculo_icms.SetParentComponent(CuponsDataset);
    CuponsDatasetvalor_base_calculo_icms.Name := 'CuponsDatasetvalor_base_calculo_icms';
    CuponsDatasetvalor_base_calculo_icms.FieldName := 'valor_base_calculo_icms';
    CuponsDatasetvalor_base_calculo_icms.DisplayFormat := '#,##0.00';
    CuponsDatasetvalor_icms.SetParentComponent(CuponsDataset);
    CuponsDatasetvalor_icms.Name := 'CuponsDatasetvalor_icms';
    CuponsDatasetvalor_icms.FieldName := 'valor_icms';
    CuponsDatasetvalor_icms.DisplayFormat := '#,##0.00';
    CuponsDatasetvalor_total_itens.SetParentComponent(CuponsDataset);
    CuponsDatasetvalor_total_itens.Name := 'CuponsDatasetvalor_total_itens';
    CuponsDatasetvalor_total_itens.FieldName := 'valor_total_itens';
    CuponsDatasetvalor_total_itens.DisplayFormat := '#,##0.00';
    CuponsDatasetvalor_total.SetParentComponent(CuponsDataset);
    CuponsDatasetvalor_total.Name := 'CuponsDatasetvalor_total';
    CuponsDatasetvalor_total.FieldName := 'valor_total';
    CuponsDatasetvalor_total.Required := True;
    CuponsDatasetvalor_total.DisplayFormat := '#,##0.00';
    CuponsDatasetcliente_fidelidade_id.SetParentComponent(CuponsDataset);
    CuponsDatasetcliente_fidelidade_id.Name := 'CuponsDatasetcliente_fidelidade_id';
    CuponsDatasetcliente_fidelidade_id.FieldName := 'cliente_fidelidade_id';
    CuponsDatasetcodigo_venda_conciliada.SetParentComponent(CuponsDataset);
    CuponsDatasetcodigo_venda_conciliada.Name := 'CuponsDatasetcodigo_venda_conciliada';
    CuponsDatasetcodigo_venda_conciliada.FieldName := 'codigo_venda_conciliada';
    CuponsDatasetorcamentos_id.SetParentComponent(CuponsDataset);
    CuponsDatasetorcamentos_id.Name := 'CuponsDatasetorcamentos_id';
    CuponsDatasetorcamentos_id.FieldName := 'orcamentos_id';
    CuponsDatasetosv_oss_id.SetParentComponent(CuponsDataset);
    CuponsDatasetosv_oss_id.Name := 'CuponsDatasetosv_oss_id';
    CuponsDatasetosv_oss_id.FieldName := 'osv_oss_id';
    CuponsDatasetdependentes_id.SetParentComponent(CuponsDataset);
    CuponsDatasetdependentes_id.Name := 'CuponsDatasetdependentes_id';
    CuponsDatasetdependentes_id.FieldName := 'dependentes_id';
    CuponsDatasetose_oss_id.SetParentComponent(CuponsDataset);
    CuponsDatasetose_oss_id.Name := 'CuponsDatasetose_oss_id';
    CuponsDatasetose_oss_id.FieldName := 'ose_oss_id';
    CuponsDatasetobservacoes.SetParentComponent(CuponsDataset);
    CuponsDatasetobservacoes.Name := 'CuponsDatasetobservacoes';
    CuponsDatasetobservacoes.FieldName := 'observacoes';
    CuponsDatasetobservacoes.Size := 255;
    CuponsDatasetnome_consumidor_final.SetParentComponent(CuponsDataset);
    CuponsDatasetnome_consumidor_final.Name := 'CuponsDatasetnome_consumidor_final';
    CuponsDatasetnome_consumidor_final.FieldName := 'nome_consumidor_final';
    CuponsDatasetnome_consumidor_final.Size := 255;
    CuponsDatasetcpf_cnpj_consumidor_final.SetParentComponent(CuponsDataset);
    CuponsDatasetcpf_cnpj_consumidor_final.Name := 'CuponsDatasetcpf_cnpj_consumidor_final';
    CuponsDatasetcpf_cnpj_consumidor_final.FieldName := 'cpf_cnpj_consumidor_final';
    CuponsDatasetcpf_cnpj_consumidor_final.Size := 255;
    CuponsDatasetdata_movimento.SetParentComponent(CuponsDataset);
    CuponsDatasetdata_movimento.Name := 'CuponsDatasetdata_movimento';
    CuponsDatasetdata_movimento.FieldName := 'data_movimento';
    CuponsDatasetdata_movimento.DisplayFormat := 'dd/mm/yy';
    CuponsDatasetrotas_id.SetParentComponent(CuponsDataset);
    CuponsDatasetrotas_id.Name := 'CuponsDatasetrotas_id';
    CuponsDatasetrotas_id.FieldName := 'rotas_id';
    CuponsDatasetconvenios_id.SetParentComponent(CuponsDataset);
    CuponsDatasetconvenios_id.Name := 'CuponsDatasetconvenios_id';
    CuponsDatasetconvenios_id.FieldName := 'convenios_id';
    CuponsDatasetsinc_scanntech.SetParentComponent(CuponsDataset);
    CuponsDatasetsinc_scanntech.Name := 'CuponsDatasetsinc_scanntech';
    CuponsDatasetsinc_scanntech.FieldName := 'sinc_scanntech';
    CuponsDatasetsinc_scanntech.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    CuponsDatasetvalor_desconto_scanntech.SetParentComponent(CuponsDataset);
    CuponsDatasetvalor_desconto_scanntech.Name := 'CuponsDatasetvalor_desconto_scanntech';
    CuponsDatasetvalor_desconto_scanntech.FieldName := 'valor_desconto_scanntech';
    CuponsDatasetvalor_desconto_scanntech.DisplayFormat := '#,##0.00';
    CuponsDatasetnfce_id.SetParentComponent(CuponsDataset);
    CuponsDatasetnfce_id.Name := 'CuponsDatasetnfce_id';
    CuponsDatasetnfce_id.FieldName := 'nfce_id';
    CuponsDatasetexcluiu_icms_base_pis_cofins.SetParentComponent(CuponsDataset);
    CuponsDatasetexcluiu_icms_base_pis_cofins.Name := 'CuponsDatasetexcluiu_icms_base_pis_cofins';
    CuponsDatasetexcluiu_icms_base_pis_cofins.FieldName := 'excluiu_icms_base_pis_cofins';
    CuponsDatasetexcluiu_icms_base_pis_cofins.Required := True;
    CuponsDatasetexcluiu_fcp_base_pis_cofins.SetParentComponent(CuponsDataset);
    CuponsDatasetexcluiu_fcp_base_pis_cofins.Name := 'CuponsDatasetexcluiu_fcp_base_pis_cofins';
    CuponsDatasetexcluiu_fcp_base_pis_cofins.FieldName := 'excluiu_fcp_base_pis_cofins';
    CuponsDatasetexcluiu_fcp_base_pis_cofins.Required := True;
    CuponsDatasetcupom_cancelado.SetParentComponent(CuponsDataset);
    CuponsDatasetcupom_cancelado.Name := 'CuponsDatasetcupom_cancelado';
    CuponsDatasetcupom_cancelado.FieldName := 'cupom_cancelado';
    CuponsDatasetcodigo_interno.SetParentComponent(CuponsDataset);
    CuponsDatasetcodigo_interno.Name := 'CuponsDatasetcodigo_interno';
    CuponsDatasetcodigo_interno.FieldName := 'codigo_interno';
    CuponsDatasetcodigo_interno.Required := True;
    CuponsDatasetexcluido.SetParentComponent(CuponsDataset);
    CuponsDatasetexcluido.Name := 'CuponsDatasetexcluido';
    CuponsDatasetexcluido.FieldName := 'excluido';
    CuponsDatasetinclusao.SetParentComponent(CuponsDataset);
    CuponsDatasetinclusao.Name := 'CuponsDatasetinclusao';
    CuponsDatasetinclusao.FieldName := 'inclusao';
    CuponsDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    CuponsDatasetalteracao.SetParentComponent(CuponsDataset);
    CuponsDatasetalteracao.Name := 'CuponsDatasetalteracao';
    CuponsDatasetalteracao.FieldName := 'alteracao';
    CuponsDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    CuponsDatasetexclusao.SetParentComponent(CuponsDataset);
    CuponsDatasetexclusao.Name := 'CuponsDatasetexclusao';
    CuponsDatasetexclusao.FieldName := 'exclusao';
    CuponsDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    CuponsDatasetnfcedata_transmissao.SetParentComponent(CuponsDataset);
    CuponsDatasetnfcedata_transmissao.Name := 'CuponsDatasetnfcedata_transmissao';
    CuponsDatasetnfcedata_transmissao.FieldName := 'nfce.data_transmissao';
    CuponsDatasetnfcedata_transmissao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    CuponsDatasetnfcechave_acesso.SetParentComponent(CuponsDataset);
    CuponsDatasetnfcechave_acesso.Name := 'CuponsDatasetnfcechave_acesso';
    CuponsDatasetnfcechave_acesso.FieldName := 'nfce.chave_acesso';
    CuponsDatasetclienterazao_social_nome.SetParentComponent(CuponsDataset);
    CuponsDatasetclienterazao_social_nome.Name := 'CuponsDatasetclienterazao_social_nome';
    CuponsDatasetclienterazao_social_nome.FieldName := 'cliente.razao_social_nome';
    CuponsDatasetfuncionarionome.SetParentComponent(CuponsDataset);
    CuponsDatasetfuncionarionome.Name := 'CuponsDatasetfuncionarionome';
    CuponsDatasetfuncionarionome.FieldName := 'funcionario.nome';
    CuponsDatasetnfcenfce_cancelada.SetParentComponent(CuponsDataset);
    CuponsDatasetnfcenfce_cancelada.Name := 'CuponsDatasetnfcenfce_cancelada';
    CuponsDatasetnfcenfce_cancelada.FieldName := 'nfce.nfce_cancelada';
    XDataClientCuponsGet.SetParentComponent(Self);
    XDataClientCuponsGet.Name := 'XDataClientCuponsGet';
    XDataClientCuponsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCuponsGet, Self, 'OnLoad', 'XDataClientCuponsGetLoad');
    XDataClientCuponsGet.Left := 696;
    XDataClientCuponsGet.Top := 176;
    cdsItens.SetParentComponent(Self);
    cdsItens.Name := 'cdsItens';
    cdsItens.EntitySetName := 'Itens_Cupons';
    cdsItens.Connection := DMConnection.ApiConnection;
    cdsItens.Left := 88;
    cdsItens.Top := 413;
    cdsItensproduto_id.SetParentComponent(cdsItens);
    cdsItensproduto_id.Name := 'cdsItensproduto_id';
    cdsItensproduto_id.FieldName := 'produto_id';
    cdsItensproduto_id.Required := True;
    cdsItensitem.SetParentComponent(cdsItens);
    cdsItensitem.Name := 'cdsItensitem';
    cdsItensitem.FieldName := 'item';
    SetEvent(cdsItensitem, Self, 'OnGetText', 'cdsItensitemGetText');
    cdsItensquantidade.SetParentComponent(cdsItens);
    cdsItensquantidade.Name := 'cdsItensquantidade';
    cdsItensquantidade.FieldName := 'quantidade';
    cdsItensquantidade.DisplayFormat := '#,##0.000';
    cdsItensproduto_preco.SetParentComponent(cdsItens);
    cdsItensproduto_preco.Name := 'cdsItensproduto_preco';
    cdsItensproduto_preco.FieldName := 'produto_preco';
    cdsItensproduto_preco.DisplayFormat := '#,##0.00';
    cdsItensvalor_total.SetParentComponent(cdsItens);
    cdsItensvalor_total.Name := 'cdsItensvalor_total';
    cdsItensvalor_total.FieldName := 'valor_total';
    cdsItensvalor_total.Required := True;
    cdsItensvalor_total.DisplayFormat := '#,##0.00';
    cdsItensproduto_nome.SetParentComponent(cdsItens);
    cdsItensproduto_nome.Name := 'cdsItensproduto_nome';
    cdsItensproduto_nome.FieldName := 'produto_nome';
    SetEvent(cdsItensproduto_nome, Self, 'OnGetText', 'cdsItensproduto_nomeGetText');
    cdsItensproduto_nome.Size := 255;
    cdsItensprodnome.SetParentComponent(cdsItens);
    cdsItensprodnome.Name := 'cdsItensprodnome';
    cdsItensprodnome.FieldName := 'prod.nome';
    cdsItensprodcodigo_interno.SetParentComponent(cdsItens);
    cdsItensprodcodigo_interno.Name := 'cdsItensprodcodigo_interno';
    cdsItensprodcodigo_interno.FieldName := 'prod.codigo_interno';
    cdsItensunidadesigla.SetParentComponent(cdsItens);
    cdsItensunidadesigla.Name := 'cdsItensunidadesigla';
    cdsItensunidadesigla.FieldName := 'unidade.sigla';
    dtsItens.SetParentComponent(Self);
    dtsItens.Name := 'dtsItens';
    dtsItens.DataSet := cdsItens;
    dtsItens.Left := 32;
    dtsItens.Top := 413;
    tmrConsultaItens.SetParentComponent(Self);
    tmrConsultaItens.Name := 'tmrConsultaItens';
    tmrConsultaItens.Enabled := False;
    SetEvent(tmrConsultaItens, Self, 'OnTimer', 'tmrConsultaItensTimer');
    tmrConsultaItens.Left := 152;
    tmrConsultaItens.Top := 416;
    cdsRecebimentos.SetParentComponent(Self);
    cdsRecebimentos.Name := 'cdsRecebimentos';
    cdsRecebimentos.EntitySetName := 'Recebimentos';
    cdsRecebimentos.Connection := DMConnection.ApiConnection;
    cdsRecebimentos.QueryTop := 10;
    cdsRecebimentos.Left := 542;
    cdsRecebimentos.Top := 427;
    cdsRecebimentosvalor_bruto_recebido.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosvalor_bruto_recebido.Name := 'cdsRecebimentosvalor_bruto_recebido';
    cdsRecebimentosvalor_bruto_recebido.FieldName := 'valor_bruto_recebido';
    cdsRecebimentosvalor_bruto_recebido.DisplayFormat := '#,##0.00';
    cdsRecebimentosdata_recebimento.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosdata_recebimento.Name := 'cdsRecebimentosdata_recebimento';
    cdsRecebimentosdata_recebimento.FieldName := 'data_recebimento';
    cdsRecebimentosdata_recebimento.DisplayFormat := 'dd/mm/yy';
    cdsRecebimentosmodalidadenome.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosmodalidadenome.Name := 'cdsRecebimentosmodalidadenome';
    cdsRecebimentosmodalidadenome.FieldName := 'modalidade.nome';
    cdsRecebimentosareceberdocumento.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosareceberdocumento.Name := 'cdsRecebimentosareceberdocumento';
    cdsRecebimentosareceberdocumento.FieldName := 'areceber.documento';
    cdsRecebimentosareceberparcela.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosareceberparcela.Name := 'cdsRecebimentosareceberparcela';
    cdsRecebimentosareceberparcela.FieldName := 'areceber.parcela';
    dtsRecebimentos.SetParentComponent(Self);
    dtsRecebimentos.Name := 'dtsRecebimentos';
    dtsRecebimentos.DataSet := cdsRecebimentos;
    dtsRecebimentos.Left := 630;
    dtsRecebimentos.Top := 427;
    dtsAReceber.SetParentComponent(Self);
    dtsAReceber.Name := 'dtsAReceber';
    dtsAReceber.DataSet := cdsAReceber;
    dtsAReceber.Left := 380;
    dtsAReceber.Top := 432;
    cdsAReceber.SetParentComponent(Self);
    cdsAReceber.Name := 'cdsAReceber';
    cdsAReceber.EntitySetName := 'Areceber';
    cdsAReceber.Connection := DMConnection.ApiConnection;
    cdsAReceber.Left := 308;
    cdsAReceber.Top := 432;
    cdsAReceberdocumento.SetParentComponent(cdsAReceber);
    cdsAReceberdocumento.Name := 'cdsAReceberdocumento';
    cdsAReceberdocumento.FieldName := 'documento';
    cdsAReceberdocumento.Size := 255;
    cdsAReceberparcela.SetParentComponent(cdsAReceber);
    cdsAReceberparcela.Name := 'cdsAReceberparcela';
    cdsAReceberparcela.FieldName := 'parcela';
    cdsAReceberparcela.Size := 255;
    cdsAReceberemissao.SetParentComponent(cdsAReceber);
    cdsAReceberemissao.Name := 'cdsAReceberemissao';
    cdsAReceberemissao.FieldName := 'emissao';
    cdsAReceberemissao.DisplayFormat := 'dd/mm/yy';
    cdsARecebervencimento.SetParentComponent(cdsAReceber);
    cdsARecebervencimento.Name := 'cdsARecebervencimento';
    cdsARecebervencimento.FieldName := 'vencimento';
    cdsARecebervencimento.Required := True;
    cdsARecebervencimento.DisplayFormat := 'dd/mm/yy';
    cdsARecebervalor_total.SetParentComponent(cdsAReceber);
    cdsARecebervalor_total.Name := 'cdsARecebervalor_total';
    cdsARecebervalor_total.FieldName := 'valor_total';
    cdsARecebervalor_total.Required := True;
    cdsARecebervalor_total.DisplayFormat := '#,##0.00';
    cdsARecebervalor_saldo_pendente.SetParentComponent(cdsAReceber);
    cdsARecebervalor_saldo_pendente.Name := 'cdsARecebervalor_saldo_pendente';
    cdsARecebervalor_saldo_pendente.FieldName := 'valor_saldo_pendente';
    cdsARecebervalor_saldo_pendente.DisplayFormat := '#,##0.00';
    cdsARecebervalor_pago.SetParentComponent(cdsAReceber);
    cdsARecebervalor_pago.Name := 'cdsARecebervalor_pago';
    cdsARecebervalor_pago.FieldName := 'valor_pago';
    cdsARecebervalor_pago.DisplayFormat := '#,##0.00';
  finally
    lbid.AfterLoadDFMValues;
    lbcliente_id.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    lbcaixa.AfterLoadDFMValues;
    lbnumero.AfterLoadDFMValues;
    lbdoc_auxiliar.AfterLoadDFMValues;
    lbcoo.AfterLoadDFMValues;
    lbmodelo.AfterLoadDFMValues;
    lbdata_emissao.AfterLoadDFMValues;
    lbdata_saida.AfterLoadDFMValues;
    lbvalor_acrescimos.AfterLoadDFMValues;
    lbvalor_descontos.AfterLoadDFMValues;
    lbvalor_base_calculo_icms.AfterLoadDFMValues;
    lbvalor_icms.AfterLoadDFMValues;
    lbvalor_total_itens.AfterLoadDFMValues;
    lbvalor_total.AfterLoadDFMValues;
    lbcodigo_venda_conciliada.AfterLoadDFMValues;
    lbobservacoes.AfterLoadDFMValues;
    lbdata_movimento.AfterLoadDFMValues;
    lbsinc_scanntech.AfterLoadDFMValues;
    lbvalor_desconto_scanntech.AfterLoadDFMValues;
    lbexcluiu_icms_base_pis_cofins.AfterLoadDFMValues;
    lbexcluiu_fcp_base_pis_cofins.AfterLoadDFMValues;
    lbcupom_cancelado.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbPaginationInfoItens.AfterLoadDFMValues;
    lbPaginationInfoAReceber.AfterLoadDFMValues;
    lbPaginationInfoRecebimentos.AfterLoadDFMValues;
    lbchave_acesso.AfterLoadDFMValues;
    lbnfce_transmissao.AfterLoadDFMValues;
    lbnfce_cancelada.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edcliente_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    edcaixa.AfterLoadDFMValues;
    ednumero.AfterLoadDFMValues;
    eddoc_auxiliar.AfterLoadDFMValues;
    edcoo.AfterLoadDFMValues;
    edmodelo.AfterLoadDFMValues;
    eddata_emissao.AfterLoadDFMValues;
    eddata_saida.AfterLoadDFMValues;
    edvalor_acrescimos.AfterLoadDFMValues;
    edvalor_descontos.AfterLoadDFMValues;
    edvalor_base_calculo_icms.AfterLoadDFMValues;
    edvalor_icms.AfterLoadDFMValues;
    edvalor_total_itens.AfterLoadDFMValues;
    edvalor_total.AfterLoadDFMValues;
    edcodigo_venda_conciliada.AfterLoadDFMValues;
    edobservacoes.AfterLoadDFMValues;
    eddata_movimento.AfterLoadDFMValues;
    edsinc_scanntech.AfterLoadDFMValues;
    edvalor_desconto_scanntech.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    pnlFormDados.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxexcluiu_icms_base_pis_cofins.AfterLoadDFMValues;
    cbxexcluiu_fcp_base_pis_cofins.AfterLoadDFMValues;
    cbxcupom_cancelado.AfterLoadDFMValues;
    tblItens.AfterLoadDFMValues;
    cbPageSizeItens.AfterLoadDFMValues;
    edSearchItens.AfterLoadDFMValues;
    pnlItensPromocao.AfterLoadDFMValues;
    btnItensTab.AfterLoadDFMValues;
    lcPaginatorItens.AfterLoadDFMValues;
    pnlTabelaAReceber.AfterLoadDFMValues;
    tblAReceber.AfterLoadDFMValues;
    lcPaginatorAReceber.AfterLoadDFMValues;
    tblRecebimentos.AfterLoadDFMValues;
    pnlTabelaPagamentos.AfterLoadDFMValues;
    btnFinanceiroTab.AfterLoadDFMValues;
    btnRecebimentosTab.AfterLoadDFMValues;
    lcPaginatorRecebimentos.AfterLoadDFMValues;
    pnlFormNfce.AfterLoadDFMValues;
    edchave_acesso.AfterLoadDFMValues;
    ednfce_transmissao.AfterLoadDFMValues;
    btnCopiarChaveAcesso.AfterLoadDFMValues;
    btnNfceTab.AfterLoadDFMValues;
    cbxnfce_cancelada.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    CuponsDataset.AfterLoadDFMValues;
    CuponsDatasetid.AfterLoadDFMValues;
    CuponsDatasetaliado_id.AfterLoadDFMValues;
    CuponsDatasetdata_base_id.AfterLoadDFMValues;
    CuponsDatasetcliente_id.AfterLoadDFMValues;
    CuponsDatasetfuncionario_id.AfterLoadDFMValues;
    CuponsDatasetcaixa.AfterLoadDFMValues;
    CuponsDatasetnumero.AfterLoadDFMValues;
    CuponsDatasetdoc_auxiliar.AfterLoadDFMValues;
    CuponsDatasetcoo.AfterLoadDFMValues;
    CuponsDatasetmodelo.AfterLoadDFMValues;
    CuponsDatasetdata_emissao.AfterLoadDFMValues;
    CuponsDatasetdata_saida.AfterLoadDFMValues;
    CuponsDatasetvalor_acrescimos.AfterLoadDFMValues;
    CuponsDatasetvalor_descontos.AfterLoadDFMValues;
    CuponsDatasetvalor_base_calculo_icms.AfterLoadDFMValues;
    CuponsDatasetvalor_icms.AfterLoadDFMValues;
    CuponsDatasetvalor_total_itens.AfterLoadDFMValues;
    CuponsDatasetvalor_total.AfterLoadDFMValues;
    CuponsDatasetcliente_fidelidade_id.AfterLoadDFMValues;
    CuponsDatasetcodigo_venda_conciliada.AfterLoadDFMValues;
    CuponsDatasetorcamentos_id.AfterLoadDFMValues;
    CuponsDatasetosv_oss_id.AfterLoadDFMValues;
    CuponsDatasetdependentes_id.AfterLoadDFMValues;
    CuponsDatasetose_oss_id.AfterLoadDFMValues;
    CuponsDatasetobservacoes.AfterLoadDFMValues;
    CuponsDatasetnome_consumidor_final.AfterLoadDFMValues;
    CuponsDatasetcpf_cnpj_consumidor_final.AfterLoadDFMValues;
    CuponsDatasetdata_movimento.AfterLoadDFMValues;
    CuponsDatasetrotas_id.AfterLoadDFMValues;
    CuponsDatasetconvenios_id.AfterLoadDFMValues;
    CuponsDatasetsinc_scanntech.AfterLoadDFMValues;
    CuponsDatasetvalor_desconto_scanntech.AfterLoadDFMValues;
    CuponsDatasetnfce_id.AfterLoadDFMValues;
    CuponsDatasetexcluiu_icms_base_pis_cofins.AfterLoadDFMValues;
    CuponsDatasetexcluiu_fcp_base_pis_cofins.AfterLoadDFMValues;
    CuponsDatasetcupom_cancelado.AfterLoadDFMValues;
    CuponsDatasetcodigo_interno.AfterLoadDFMValues;
    CuponsDatasetexcluido.AfterLoadDFMValues;
    CuponsDatasetinclusao.AfterLoadDFMValues;
    CuponsDatasetalteracao.AfterLoadDFMValues;
    CuponsDatasetexclusao.AfterLoadDFMValues;
    CuponsDatasetnfcedata_transmissao.AfterLoadDFMValues;
    CuponsDatasetnfcechave_acesso.AfterLoadDFMValues;
    CuponsDatasetclienterazao_social_nome.AfterLoadDFMValues;
    CuponsDatasetfuncionarionome.AfterLoadDFMValues;
    CuponsDatasetnfcenfce_cancelada.AfterLoadDFMValues;
    XDataClientCuponsGet.AfterLoadDFMValues;
    cdsItens.AfterLoadDFMValues;
    cdsItensproduto_id.AfterLoadDFMValues;
    cdsItensitem.AfterLoadDFMValues;
    cdsItensquantidade.AfterLoadDFMValues;
    cdsItensproduto_preco.AfterLoadDFMValues;
    cdsItensvalor_total.AfterLoadDFMValues;
    cdsItensproduto_nome.AfterLoadDFMValues;
    cdsItensprodnome.AfterLoadDFMValues;
    cdsItensprodcodigo_interno.AfterLoadDFMValues;
    cdsItensunidadesigla.AfterLoadDFMValues;
    dtsItens.AfterLoadDFMValues;
    tmrConsultaItens.AfterLoadDFMValues;
    cdsRecebimentos.AfterLoadDFMValues;
    cdsRecebimentosvalor_bruto_recebido.AfterLoadDFMValues;
    cdsRecebimentosdata_recebimento.AfterLoadDFMValues;
    cdsRecebimentosmodalidadenome.AfterLoadDFMValues;
    cdsRecebimentosareceberdocumento.AfterLoadDFMValues;
    cdsRecebimentosareceberparcela.AfterLoadDFMValues;
    dtsRecebimentos.AfterLoadDFMValues;
    dtsAReceber.AfterLoadDFMValues;
    cdsAReceber.AfterLoadDFMValues;
    cdsAReceberdocumento.AfterLoadDFMValues;
    cdsAReceberparcela.AfterLoadDFMValues;
    cdsAReceberemissao.AfterLoadDFMValues;
    cdsARecebervencimento.AfterLoadDFMValues;
    cdsARecebervalor_total.AfterLoadDFMValues;
    cdsARecebervalor_saldo_pendente.AfterLoadDFMValues;
    cdsARecebervalor_pago.AfterLoadDFMValues;
  end;
end;

end.
